import { useNavigate, Link, useLocation } from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import { parse, isValid, format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import TokenService from "../../../Services/Token.service";
import { LabsService } from "../../../Services/Labs.service";
import { SampleService } from "../../../Services/Sample.service";
import Toaster from "../../../Components/Toaster";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Loader from "../../../Components/Loader";
import SpecialDonor from "../../../Components/AdministrativeSettings/SampleRequest/SpecialDonor";
import ExcludedDonor from "../../../Components/AdministrativeSettings/SampleRequest/ExcludedDonor";
import Autocomplete from "../../../Components/AdministrativeSettings/Autocomplete";
import { Accordion, Button, Col, Dropdown, Row } from "react-bootstrap";
import TrainingStatusModal from "../../../Components/AdministrativeSettings/RequestorManagement/TrainingStatusModal";
import SchedulePickupSampleRequestModal from "./SchedulePickupSampleRequestModal";
import { getStatusLabel, SampleRequestService } from "../../../Services/SampleRequest.Service";
import CustomFields from "../../../Components/AdministrativeSettings/SampleRequest/CustomFields";
import UserProfileDetails from "../../../Components/AdministrativeSettings/UserProfileDetails";
import { RequestorService } from "../../../Services/Requestor.Service";
import ConfirmationModal from "../../../Components/ConfirmationModal";
import { Helmet } from "react-helmet";


function NewRequest() {


    //Navigate to Profile Settings 

    const [showProfileSettingsModal, setShowProfileSettingsModal] = useState(false);
 
    const handleShowProfileSettingsModal = () => {
    
        setShowProfileSettingsModal(true);
    };
    const handleCloseProfileSettingsModal = () => {
        setShowProfileSettingsModal(false);
    
    }; 
    const confirmProfileSettings = async () => { 
        handleCloseProfileSettingsModal();        
        const validationErrors = await  formikRef.current.validateForm();

        // Filter errors for project_name and lab_id
        const draftErrors = Object.keys(validationErrors).filter(
            (key) => key === 'project_name' || key === 'lab_id'
        );

        // Check if there are no errors in project_name and lab_id
        if (draftErrors.length === 0) {            
            if(showProfileSettingsModal){
                handleSubmit(formikRef.current.values, true); // Call handleSubmit when there are no errors
            }
        } else {
            // handleScrollUpOnDraftSubmit(validationErrors); // Scroll to the errors
            navigate('/profile-management/profile-settings'); 
        }
    

        
    };  

    const goToUserProfileSettings = ()=>{
        handleShowProfileSettingsModal();         
        // to={`/profile-management/profile-settings`}
    }

   
    const [activeField, setActiveField] = useState('');
    const [samples, setSamples] = useState({}); // Get all samples 
    const location = useLocation();
    const [requestId,setRequestId] = useState(location.state?.id);
    useEffect(() => {        
        // Retrieve state from sessionStorage
        const savedState = sessionStorage.getItem('newSampleRequestState');
        if (savedState) {
            setRequestId(JSON.parse(savedState).id); 
            // Optionally clear the saved state to prevent reuse
            sessionStorage.removeItem('newSampleRequestState');
        }
    }, []);
    const [sampleRequestDetails, setSampleRequestDetails] = useState(null); 
    
    useEffect(()=>{ 
        setSelectedLab(sampleRequestDetails?.request?.lab_id); 
        fetchDurationCompensationAppointment();
        if(sampleRequestDetails){ 
            fetchSampleTypes();
        }
    },[sampleRequestDetails])

    const [donorDemographicsDataFromDetails, setDonorDemographicsDataFromDetails] =  useState({});
    useEffect(() => {
        
        setLoading(true);
        
        if (sampleRequestDetails && sampleRequestDetails?.request) {  
            setDonorDemographicsDataFromDetails(sampleRequestDetails.request.sample_request_demographics);
            const editValues = mapApiDataToForm(sampleRequestDetails?.request, sampleRequestDetails);
          
            setVoluenteers(sampleRequestDetails.request.volunteers);
            setSpecialDonor({ special_donor: transformApiDataToSpecialDonor(sampleRequestDetails.request) });
            const transformApiDataToSampleRequestIDsEdit = transformApiDataToSampleRequestIDs(sampleRequestDetails.request.rq_samples)
            setSelectedSampleIds(transformApiDataToSampleRequestIDsEdit );
            setExcludedDonorIds(transformApiDataToExcludedDonors(sampleRequestDetails.request)?.exclude_donors || []);
            formikRef.current.setFieldValue("sample_types", transformApiDataToSampleRequestIDsEdit); //selectedSampleIds
            if(samples.length > 0 && selectedSampleIds!=null){ 
                handleSampleApply();
            }
            // Map rq_samples and create keys with sample_id
            sampleRequestDetails.request.rq_samples.forEach((sample) => {
                
                const sampleId = sample.sample_id;
                // Dynamically add keys with sample_id suffix
                editValues[`expiration_date_${sampleId}`] = new Date(sample.expiration_date) || null;
                editValues[`unprocess_number_${sampleId}`] = sample.unprocess_number || "";
                editValues[`unprocess_unit_${sampleId}`] = sample.unprocess_unit || "";
                editValues[`is_fasting_${sampleId}`] = sample.is_fasting ? "Yes" : "No"  || "";
                editValues[`fasting_duration_${sampleId}`] = sample.fasting_duration || "";
                editValues[`fasting_duration_unit_${sampleId}`] = sample.fasting_unit || "hours";

                editValues[`instruction_${sampleId}`] = sample.instruction || "";
                editValues[`special_donors_${sampleId}`] =  transformDataToSpecialDonors(sample)   || [];  
                editValues[`is_special_donor_${sampleId}`] = sample.is_special_donor ? "Yes" : "No"  || "";
                // Map sample_info fields with sample_id
                sample.samples_info.forEach((info) => {
                    // editValues[`${info.field_name}_${sampleId}`] = info.field_value || "";
                    if(  info.field_value !=null &&  info.field_value !="0" ){  //allowing except 0 and null

                        editValues[`${info.field_name}`] = info.field_value || "";
                    }
                    if(sampleId==5){
          
                    }
                });
            });
        
      
            setInitialValues(editValues);
       
        } 
        setLoading(false);
    }, [samples,sampleRequestDetails]);
    // useEffect(() => {
    //     if (sampleRequestDetails) {
    //         const sampleRequestData = {};
    
    //         // Iterate over each sample in rq_samples
    //         sampleRequestDetails.request.rq_samples.forEach((sample) => {
    //             const sampleId = sample.sample_id;
    
    //             // Initialize the structure for each sample
    //             const sampleData = {
    //                 expiration_date: sample.expiration_date || null,
    //                 unprocess_number: sample.unprocess_number || "",
    //                 unprocess_unit: sample.unprocess_unit || "mins",
    //                 is_fasting: sample.is_fasting ? "Yes" : "No" || "",
    //                 fasting_duration: sample.fasting_duration || "",
    //                 instruction: sample.instruction || "",
    //                 is_special_donor: sample.is_special_donor  ? "Yes" : "No" || "",
    //                 special_donor: {
    //                     preferred_donor: {
    //                         donor_ids: sample.preferred_donor?.donor_ids || [],
    //                         quantity: sample.preferred_donor?.quantity || [],
    //                         gender: sample.preferred_donor?.gender || [],
    //                         female_qty: sample.preferred_donor?.female_qty || 0,
    //                         male_qty: sample.preferred_donor?.male_qty || 0,
    //                     },
    //                     alternate_donor: {
    //                         donor_ids: sample.alternate_donor?.donor_ids || [],
    //                         quantity: sample.alternate_donor?.quantity || [],
    //                         gender: sample.alternate_donor?.gender || [],
    //                         female_qty: sample.alternate_donor?.female_qty || 0,
    //                         male_qty: sample.alternate_donor?.male_qty || 0,
    //                     },
    //                 },
    //                 selected_donor_ids: sample.selected_donor_ids || [],
    //                 options: sample.options || {},
    //             };
    
    //             // Set the sample data in the sampleRequest object by sample_id
    //             sampleRequestData[sampleId] = sampleData;
    //         });
    
    //         // Set the sampleRequest state
    //         setSampleRequest(sampleRequestData);
    
    //         // Optionally, set initial values for the form if needed
    //         const editValues = mapApiDataToForm(sampleRequestDetails.request);
    //         setInitialValues(editValues);
    //     }
    // }, [sampleRequestDetails]);
    useEffect(() => {
        if (sampleRequestDetails) {
            setLoading(true);
            // Initialize data structures
            const sampleRequestData = {};
            const updatedSpecialDonor = { special_donor: resetSpecialDonor() }; // Start with the reset state
    
            // Iterate over each sample in `rq_samples`
            sampleRequestDetails.request.rq_samples.forEach((sample) => {
                const sampleId = sample.sample_id;
    
                // Parse and calculate special donor data
                // const specialDonorGender = JSON.parse(sample.special_donor_gender || "[]").map((gender) =>
                //     gender === "XY" ? "male" : gender === "XX" ? "female" : gender
                // );
                // const specialDonorQuantity = JSON.parse(sample.special_donor_gender_quantity || "[]");
                // let specialMaleQty = 0;
                // let specialFemaleQty = 0;
            
                // specialDonorGender.forEach((gender, index) => {
                //     const quantity = specialDonorQuantity[index] || 0;
                //     if (gender === "male") {
                //         specialMaleQty += quantity; // Accumulate male quantity
                //     } else if (gender === "female") {
                //         specialFemaleQty += quantity; // Accumulate female quantity
                //     }
                // });
            
                // Parse and calculate alternate donor data
                // const alternateDonorGender = JSON.parse(sample.alternate_donor_gender || "[]").map((gender) =>
                //     gender === "XY" ? "male" : gender === "XX" ? "female" : gender
                // );
                // const alternateDonorQuantity = JSON.parse(sample.alternate_donor_gender_quantity || "[]");
                // let maleQty = 0;
                // let femaleQty = 0;
            
                // alternateDonorGender.forEach((gender, index) => {
                //     const quantity = alternateDonorQuantity[index] || 0;
                //     if (gender === "male") {
                //         maleQty += quantity;
                //     } else if (gender === "female") {
                //         femaleQty += quantity;
                //     }
                // });
                // Create a structured object for the sample data
                const sampleData = {
                    expiration_date: sample.expiration_date || null,
                    unprocess_number: sample.unprocess_number || "",
                    unprocess_unit: sample.unprocess_unit || "mins",
                    is_fasting: sample.is_fasting ? "Yes" : "No",
                    fasting_duration: sample.fasting_duration || "",
                    fasting_duration_unit: sample.fasting_unit || "hours",
                    instruction: sample.instruction || "",
                    is_special_donor: sample.is_special_donor ? "Yes" : "No",
                    
                    special_donor: {
                        preferred_donor: {
                            donor_ids: JSON.parse(sample.special_donor_ids) || [],
                            // quantity: specialDonorQuantity,
                            // gender: specialDonorGender,
                            // female_qty: specialFemaleQty,
                            // male_qty: specialMaleQty,
                        },
                        // alternate_donor: {
                        //     donor_ids: JSON.parse(sample.alternate_donor_ids || "[]"),
                        //     quantity: alternateDonorQuantity,
                        //     gender: alternateDonorGender,
                        //     female_qty: femaleQty,
                        //     male_qty: maleQty,
                        // },
                    },
                    selected_donor_ids: sample.selected_donor_ids || [],
                    options: sample.samples_info.reduce((acc, info) => {
                        // Convert field_value to `true` if it's "1", otherwise use the actual value
                        acc[info.field_name] =   info.field_value;
                        // acc[info.field_name] = info.field_value === "1" ? true : info.field_value;
                        return acc;
                    }, {}),
                    
                }; 
                // // Update special donor data if applicable
                // if (sample.is_special_donor) {
                //     updatedSpecialDonor.special_donor.preferred_donor.donor_ids = [
                //         ...updatedSpecialDonor.special_donor.preferred_donor.donor_ids,
                //         ...(sample.preferred_donor?.donor_ids || [])
                //     ];
                //     updatedSpecialDonor.special_donor.preferred_donor.quantity = [
                //         ...updatedSpecialDonor.special_donor.preferred_donor.quantity,
                //         ...(sample.preferred_donor?.quantity || [])
                //     ];
                //     updatedSpecialDonor.special_donor.preferred_donor.gender = [
                //         ...updatedSpecialDonor.special_donor.preferred_donor.gender,
                //         ...(sample.preferred_donor?.gender || [])
                //     ];
                //     updatedSpecialDonor.special_donor.preferred_donor.female_qty += sample.preferred_donor?.female_qty || 0;
                //     updatedSpecialDonor.special_donor.preferred_donor.male_qty += sample.preferred_donor?.male_qty || 0;
    
                //     updatedSpecialDonor.special_donor.alternate_donor.donor_ids = [
                //         ...updatedSpecialDonor.special_donor.alternate_donor.donor_ids,
                //         ...(sample.alternate_donor?.donor_ids || [])
                //     ];
                //     updatedSpecialDonor.special_donor.alternate_donor.quantity = [
                //         ...updatedSpecialDonor.special_donor.alternate_donor.quantity,
                //         ...(sample.alternate_donor?.quantity || [])
                //     ];
                //     updatedSpecialDonor.special_donor.alternate_donor.gender = [
                //         ...updatedSpecialDonor.special_donor.alternate_donor.gender,
                //         ...(sample.alternate_donor?.gender || [])
                //     ];
                //     updatedSpecialDonor.special_donor.alternate_donor.female_qty += sample.alternate_donor?.female_qty || 0;
                //     updatedSpecialDonor.special_donor.alternate_donor.male_qty += sample.alternate_donor?.male_qty || 0;
                // }
    
                // Assign the sample data to the corresponding ID
                sampleRequestData[sampleId] = sampleData;
            }); 
            // Update the sample request state
            setSampleRequest(sampleRequestData);
    
            // Update the special donor state if there is any data
            // if (
            //     updatedSpecialDonor.special_donor.preferred_donor.donor_ids.length > 0 ||
            //     updatedSpecialDonor.special_donor.alternate_donor.donor_ids.length > 0
            // ) {
            //     setSpecialDonor(updatedSpecialDonor);
            // }
    
            // // Map API data to initial form values if necessary
            // const editValues = mapApiDataToForm(sampleRequestDetails.request);
            // setInitialValues(editValues);
            setLoading(false);
        }
    }, [sampleRequestDetails]);
    
    
    const transformApiDataToSampleRequestIDs = (rq_samples) => {
        const result = {};
        rq_samples.forEach((sample) => {
            result[sample.sample_id] = true;
        });
        return result;
    };
     
    const mapApiDataToForm = (data, completeData) => {
     const parentStudy =
    Array.isArray(completeData.parentstudy) && completeData.parentstudy.length > 0
      ? completeData.parentstudy[0]
      : {};

  const isPartOfParentStudy = parentStudy.is_parent_study === 'yes' ? 'Yes' : 'No';
        return {
        project_name: data.project_name || '',
        requestor_id: data.user_id || requestorId,
        lab_id: data.lab_id || '',
        is_partof_parent_study: isPartOfParentStudy,
        parent_study_id: isPartOfParentStudy === 'Yes'
        ? parentStudy.parent_study_id || ''
        : '', 
        exclude_parent_study_donors: data.exclude_parent_study_donors || 'No',
        wbs_element: data.wbs_element || '',
        volunteers: data.volunteers || 1,
        smoker_allowed: data.smoker_allowed == 'yes' ? 'Yes' : 'No'  || '',
        vitamins_herbal_allowed: data.herbal_vitamins == 'yes' ? 'Yes' : 'No' || '',
        all_medication_allowed: data.medication_allowed == 'yes' ? 'Yes' : 'No' || '',
        excluded_medication: data.medication_reason || '',
        last_does_vitamins: data.herbal_vitamin_note || '',
        donor_restriction: data.donor_restriction_note || '',
        // age_from: data.age_from || 18,
        // age_to: data.age_to || 65,
        matched_sample: data.matched_sample == 'yes' ? 'Yes' : 'No'  || '',
        is_special_donor: data.is_special_donor  ? 'Yes' : 'No'  || '',
        is_exclude_donor: data.is_exclude_donors  ? 'Yes' : 'No'  || '',
        // exclude_donors: data.excluded_donor_ids ? JSON.parse(data.excluded_donor_ids) : [],
        // special_donors: data.special_donor_ids ? JSON.parse(data.special_donor_ids) : [],
        special_donors: transformDataToSpecialDonors(data),
        exclude_donors: transformApiDataToExcludedDonors(data).exclude_donors,
        initial: data.acknoledgement_initials || '',
        // scheduled_pickup: data.sample_pickup_date || '',
        confirm_info: true,

        sample_types : {},
        //comment this is not correct kept because not working for edit -> formikRef.current.setFieldValue("sample_types", selectedSampleIds);
        // sample_types: data.rq_samples.reduce((acc, sample) => {
        //     acc[sample.sample_id] = {
        //         ...sample,
        //         samples_info: sample.samples_info.reduce((infoAcc, info) => {
        //             infoAcc[info.field_name] = info.field_value;
        //             return infoAcc;
        //         }, {})
        //     };
        //     return acc;
        // }, {})
    };
}
    

    //for setting up initial_value's special_donors
    const transformDataToSpecialDonors = (data) => {
        let specialDonors = [];
    
        // Add preferred donor IDs
        if (data.special_donor_ids) {
            const preferredIds = JSON.parse(data.special_donor_ids);
            preferredIds.forEach((id) => {
                specialDonors.push(`preferred-${id}`);
            });
        }
    
        // Add genders for preferred donors based on quantities
        if (data.special_donor_gender && data.special_donor_gender_quantity) {
            const genders = JSON.parse(data.special_donor_gender);
            const quantities = JSON.parse(data.special_donor_gender_quantity);
    
            genders.forEach((gender, index) => {
                if (quantities[index] > 0) {
                    specialDonors.push(`preferred-${gender === "XY" ? "male" : "female"}`);
                }
            });
        }
    
        // // Add alternate donor IDs
        // if (data.alternate_donor_ids) {
        //     const alternateIds = JSON.parse(data.alternate_donor_ids);
        //     alternateIds.forEach((id) => {
        //         specialDonors.push(`alternate-${id}`);
        //     });
        // }
    
        // // Add genders for alternate donors based on quantities
        // if (data.alternate_donor_gender && data.alternate_donor_gender_quantity) {
        //     const genders = JSON.parse(data.alternate_donor_gender);
        //     const quantities = JSON.parse(data.alternate_donor_gender_quantity);
    
        //     genders.forEach((gender, index) => {
        //         if (quantities[index] > 0) {
        //             specialDonors.push(`alternate-${gender === "XY" ? "male" : "female"}`);
        //         }
        //     });
        // }
    
        return specialDonors;
    };
    
    const transformApiDataToSpecialDonor = (apiData) => {
        const parseJSON = (data) => {
            try {
                return JSON.parse(data);
            } catch {
                return []; // Return an empty array if parsing fails
            }
        };
    
        const safeGetQuantity = (quantityArray, index) => {
            return Array.isArray(quantityArray) ? quantityArray[index] || 0 : 0;
        };
    
        return {
            preferred_donor: {
                 donor_ids: apiData?.special_donor_ids
                    ? JSON.parse(apiData.special_donor_ids)
                    : []
                // quantity: parseJSON(apiData.special_donor_gender_quantity),
                // gender: parseJSON(apiData.special_donor_gender)?.map((g) => g === "XY" ? "male" : "female") || [],
                // female_qty: safeGetQuantity(parseJSON(apiData.special_donor_gender_quantity), 1),
                // male_qty: safeGetQuantity(parseJSON(apiData.special_donor_gender_quantity), 0),
            },
            // alternate_donor: {
            //     donor_ids: parseJSON(apiData.alternate_donor_ids),
            //     quantity: parseJSON(apiData.alternate_donor_gender_quantity),
            //     gender: parseJSON(apiData.alternate_donor_gender)?.map((g) => g === "XY" ? "male" : "female") || [],
            //     female_qty: safeGetQuantity(parseJSON(apiData.alternate_donor_gender_quantity), 1),
            //     male_qty: safeGetQuantity(parseJSON(apiData.alternate_donor_gender_quantity), 0),
            // },
        };
    };
    
    const transformApiDataToExcludedDonors = (apiData) => {
        const parseJSON = (data) => {
            try {
                return JSON.parse(data);
            } catch {
                return []; // Return an empty array if parsing fails
            }
        };
    
        return {
            exclude_donors: parseJSON(apiData.excluded_donor_ids),
        };
    };
    

    useEffect(() => {
        if (requestId) { 
            SampleRequestService.getSampleRequestDetails(requestId)
                .then((data) => { 
                    setSampleRequestDetails(data);
                    setLoading(false); 
                })
                .catch((err) => {
                    console.error("Error fetching sample type data:", err);
                    setToastMessage(err.message);
                    setToastVariant('error');
                    setShowToast(true);
                    setLoading(false);
                });
        } else {
            setLoading(false);

        }
    }, [requestId]);


    const handleDuplicateRequest = async (userId) => {
        try {

            const baseUrl = process.env.REACT_APP_BASE_URL || "";
            const response = await SampleRequestService.duplicateSampleRequest(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Sample request duplication successfully:", response);

                 // Use response.request_id to navigate
                const { duplicate_id } = response;
                // const  request_id  = userId;
                // navigate(`/requestor/request-new-sample`, { state: { id: duplicate_id } });
                
                sessionStorage.setItem('newSampleRequestState', JSON.stringify({ id: duplicate_id }));

            
                const newTabUrl = `${baseUrl}/requestor/request-new-sample`;
                window.open(newTabUrl, '_blank');
                // fetchSampleTypeList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to duplicate sample request:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
        }
    };

    const handleDeleteRequest = async (userId) => {
        setLoading(true);
        try {
            const response = await SampleRequestService.deleteSampleRequest(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                // setShowToast(true);
                setToastVariant('success');
                console.log("Sample request draft deleted successfully:", response);
                // fetchSampleTypeList();
                setNavigateToSampleRequestList(true);
                setLoading(false);
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) {
            console.error("Failed to delete request draft:", error);
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
    };

    //duplicate//edit

    const [showSubmitModal, setShowSubmitModal] = useState(false);
    const [submit, setSubmit] = useState(null);
    const handleShowSubmitModal = (values, draft) => {
        const hasCustomFieldErrors = Object.values(customFieldError).some(error => error !== null && error !== ''); 
        
        if(!sampleTypeError && !hasCustomFieldErrors) {
            const submit = {
                values,
                draft
            }
            setSubmit(submit);
            setShowSubmitModal(true);
        } else {
            const fieldError = Object.entries(customFieldError).find(
                ([key, error]) => error !== null && error !== ''
            );                  
            const fieldErrorIndex = fieldError ? fieldError[0] : null;

            if (fieldErrorIndex && sampleFieldRef.current[fieldErrorIndex]) {
                sampleFieldRef.current[fieldErrorIndex].scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        }
    };
    const handleCloseSubmitModal = () => {
        setShowSubmitModal(false);
    };

    const confirmSubmit = () => {
        handleCloseSubmitModal();
        // handleSampleRemovalAction(selectedSampleId);   
        handleSubmit(submit.values, submit.draft);
        handleCloseDeleteModal();
    };


    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedSampleId, setSelectedSampleId] = useState(null);
    const handleShowDeleteModal = (sampleId) => {
        setSelectedSampleId(sampleId);
        setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedSampleId(null);
    };

    const confirmDeleteUser = () => {
        if (selectedSampleId !== null) {
            handleSampleRemovalAction(selectedSampleId);
        }
        handleCloseDeleteModal();
    };

    const [navigateToSampleRequestList, setNavigateToSampleRequestList] = useState(false);
    const [navigateToProfileSettings, setNavigateToProfileSettings] = useState(false);
    const [requestorData, setRequestorData] = useState(null);
    const dateFormat = "MMMM d, yyyy";
    const navigate = useNavigate();
    const { isSidebarVisible } = useContext(GlobalInfo);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [loading, setLoading] = useState(false);
    const [validationSchema, setValidationSchema] = useState(Yup.object());
    const [minStartDate, setMinStartDate] = useState(null);
    const boxRefs = useRef([]);
    const formikRef = useRef();
    const sampleRef = useRef(null);
    const sampleFieldRef = useRef({});
    const [previousUrl, setPreviousUrl] = useState('');
    // const requestorId = TokenService.getUserId();
    const [requestorId, setRequestorId] = useState(TokenService.getUserId());
    //code to chage behaviour of back button navigation on < sample requests




    useEffect(() => {
        let url = TokenService.getPrevLink();
        if (url === '/requestor/request-new-sample') {
            url = '/requestor/requestor-sample-requests';
        }
        setPreviousUrl(url);
    }, []);

    const [initialValues, setInitialValues] = useState({
        project_name: '',
        requestor_id: requestorId,
        lab_id: '',

        is_partof_parent_study: '', // Yes | No
        parent_study_id:'',
        exclude_parent_study_donors :'', // Yes | No

        wbs_element: '',
        volunteers: 1,
        smoker_allowed: '',
        vitamins_herbal_allowed: '',
        all_medication_allowed: '',
        excluded_medication: '',
        last_does_vitamins: '',
        donor_restriction: '',
        // age_from: 18,
        // age_to: 65,
        matched_sample: '',
        is_special_donor: '',
        is_exclude_donor: '',
        exclude_donors: [],
        special_donors: [],
        initial: '',
        scheduled_pickup: '',
        confirm_info: false,
        sample_types: {}
    });

    const [labs, setLabs] = useState([]);
    const [voluenteers, setVoluenteers] = useState(initialValues.volunteers);
    const [isOpen, setIsOpen] = useState(false);
    const duration = {
        hours: 'Hours',
        mins: 'Minutes',
    }

    const [parentStudy, setParentStudy] = useState([]);

    const resetSpecialDonor = () => {
        return {
            preferred_donor: {
                donor_ids: [],
                // quantity: [],
                // gender: [],
                // female_qty: 0,
                // male_qty: 0,
            },
            // alternate_donor: {
            //     donor_ids: [],
            //     quantity: [],
            //     gender: [],
            //     female_qty: 0,
            //     male_qty: 0,
            // }
        };
    };

    /**
     * States related to Donor
     */
    const [specialDonorField, setSpecialDonorField] = useState(false);
    const [selectedDonorIds, setSelectedDonorIds] = useState([]);
    const [excludedDonorIds, setExcludedDonorIds] = useState([]);
    useEffect(()=>{
            // const [excludedDonorIds, setExcludedDonorIds] = useState([]);
        }, [excludedDonorIds]);
            
    const [specialDonor, setSpecialDonor] = useState({
        special_donor: resetSpecialDonor()
    });
    useEffect(()=>{ 
            // const [excludedDonorIds, setExcludedDonorIds] = useState([]);
        }, [specialDonor]);
    /**
     * States related sample
     */
    const [sampleMatched, setSampleMatched] = useState(false);
    // const [samples, setSamples] = useState({}); // Get all samples 
    const [selectedSampleIds, setSelectedSampleIds] = useState({}); // For selected sample IDs
    const [deletedSampleIds, setDeletedSampleIds] = useState({}); // For selected sample IDs
    const [selectedSamples, setSelectedSamples] = useState({}); // For selected sample data
    const [sampleFields, setSampleFields] = useState({}); // For Custom Fields
    const [sampleTypeError, setSampleTypeError] = useState('Please select at least one sample type.');  // Custom Error hadling for selection of sample  
    const [sampleRequest, setSampleRequest] = useState({}); // Store sample related data pass to API in Add/Edit
    useEffect(()=>{ 
        //console.log("sampleRequest ===== ",sampleRequest);
    },[sampleRequest])
    const [sampleSelectedDonor, setSampleSelectedDonor] = useState({});
    const [groupTotal, setGroupTotal] = useState({});  
    const[selectedLab, setSelectedLab] = useState();
    /**
     * Sample Custom Fields
     */
    const [customFieldError, setCustomFieldError] = useState({});
    const groupCheck = ["blood-tubes", "urine-sample-type", "exhaled-breathe-sample-type", "saliva-sample-type", "buccal-swab-sample-type", "hair-follic-sample-type", "skin-tape-sample-type", "stool-sample-type"];

    /**
     * Handle Validations
     */
    const staticValidationSchema = Yup.object().shape({
        project_name: Yup.string()
            .max(100, 'Project Name must not be more than 100 characters long')
            .required('Please enter project name'),
        lab_id: Yup.string().required('Lab selection is required'),

        is_partof_parent_study: Yup.string().required('This is required'),
        
        parent_study_id: Yup.string().when('is_partof_parent_study', {
            is: (val) => val === 'Yes',
            then: (schema) => schema.required('This field is required'),
            otherwise: (schema) => schema
        }),
        exclude_parent_study_donors: Yup.string().when('is_partof_parent_study', {
        is: (val) => val === 'Yes',
        then: (schema) => schema.required('This field is required'),
        otherwise: (schema) => schema.notRequired()
        }),

        wbs_element: Yup.string()
            .max(100, 'WBS element must not be more than 100 characters long')
            .required('WBS element is required'),
        volunteers: Yup.number()
            .typeError('Please enter the number of volunteers')
            .required('Please enter number of volunteers')
            .positive('This must be a positive number')
            .integer('This must be an Integer')
            .min(1, 'Minimum one volunteers must be added'),
        smoker_allowed: Yup.string().required('This is required'),
        vitamins_herbal_allowed: Yup.string().required('This is required'),
        all_medication_allowed: Yup.string().required('This is required'),
        excluded_medication: Yup.string().when('all_medication_allowed', (all_medication_allowed, schema) => {
            return all_medication_allowed[0] === 'No'
                ? schema.required('This field is required').matches(/^[a-zA-Z0-9 ]*$/, 'Only alphanumeric characters are allowed')
                : schema.notRequired().matches(/^[a-zA-Z0-9 ]*$/, 'Only alphanumeric characters are allowed');
        }),
        donor_restriction: Yup.string(),
        // .matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric characters are allowed'),
        last_does_vitamins: Yup.string().when('vitamins_herbal_allowed', (vitamins_herbal_allowed, schema) => {
            return vitamins_herbal_allowed[0] === 'No'
                ? schema.required('This field is required').matches(/^[a-zA-Z0-9 ]*$/, 'Only alphanumeric characters are allowed')
                : schema.notRequired().matches(/^[a-zA-Z0-9 ]*$/, 'Only alphanumeric characters are allowed');
        }),
        // age_from: Yup.number()
        //     .positive('This must be a positive number')
        //     .integer('This must be an Integer')
        //     .min(18, 'Minimum 18 years allowed')
        //     .max(65, 'Maximum 65 age can be allowed'),
        // age_to: Yup.number()
        //     .positive('This must be a positive number')
        //     .integer('This must be an Integer')
        //     .min(18, 'Minimum 18 years allowed')
        //     .max(65, 'Maximum 65 age can be allowed'),
        //matched_sample: Yup.string().required('This is required'),
        matched_sample: Yup.string()
            .when('sample_types', (sample_types, schema) => {    
               
                return sample_types && Array.isArray(sample_types) && sample_types.length > 0 && Object.keys(sample_types[0]).length > 1
                    ? schema.required('This field is required')
                    : schema.notRequired();
        }),
        is_exclude_donor: Yup.string()
            .required('This is required')
            .test('is-exclude-donor-check', 'Excluded donor IDs cannot be empty', function(value) {  
                const { exclude_donors } = this.parent;
                if (value === 'Yes' && (!exclude_donors || exclude_donors.length === 0)) {
                    return false; 
                }
                return true; 
        }),
        is_special_donor: Yup.string()
            .when('matched_sample', (matched_sample, schema) => {
                return matched_sample[0] === 'Yes'
                    ? schema.required('This field is required')
                    : schema.notRequired();
            // }).test('is-special-donor-validation', 'Special donor IDs cannot be empty', function (value) {
            }).test('is-special-donor-validation', 'Specifiy Donor ID or Specify Donor Groups by Demographics', function (value) {
                const { special_donors, special_donor_donorDemographicsData } = this.parent; 
                if (value === 'Yes' && ((!special_donors || special_donors.length === 0) && ( !special_donor_donorDemographicsData || special_donor_donorDemographicsData.length == 0 ))) {
                    return false; 
                }
                return true; 
        }),
        initial: Yup.string()
            .min(3, 'Minimum 3 characters required')
            .max(10, 'Maximum 10 characters allowed')
            .required('This is required'),
        scheduled_pickup:
            Yup.object()
                .required('Please Schedule Sample Collection Pickup Date & Time')
                .nullable(),
        confirm_info: Yup.boolean()
            .oneOf([true], 'Please confirm your information')
            .required('Please confirm your information'),

        sample_types: Yup.object()
            .test(
                "at-least-one-checked",
                "Please select at least one sample type",
                (value) => value && Object.values(value).some((isChecked) => isChecked)
            )
            .required("Sample type selection is required"),     
    });

    useEffect(() => {
        if (sampleMatched === false || specialDonorField === false) {
            setSpecialDonor({
                special_donor: resetSpecialDonor()
            });
            // formikRef.current.setFieldValue("special_donors",[]);
            // formikRef.current.setFieldValue("special_donor_donorDemographicsData",[]);

            setSelectedDonorIds([]);
        }
        if (sampleMatched === true) {
            
            const updatedSampleRequest = { ...sampleRequest };
            Object.keys(updatedSampleRequest).forEach((key) => {
                updatedSampleRequest[key].is_special_donor =  "No";
                updatedSampleRequest[key].special_donor = resetSpecialDonor();
                updatedSampleRequest[key].selected_donor_ids = [];

                // formikRef.current.setFieldValue(`special_donors_${key}`,[]);
                // formikRef.current.setFieldValue(`special_donor_donorDemographicsData_${key}`,[]);
            });


            setSampleRequest(updatedSampleRequest);
        }
    }, [sampleMatched, specialDonorField]);


    useEffect(() => {
        
        const validTypes = ['Dropdown', 'Input'];
        if (selectedSamples.length > 0) {

            const sampleIds = selectedSamples.map(sample => sample.id);
            let filteredSampleFields = [];
            if (Array.isArray(sampleFields)) {
                filteredSampleFields = sampleFields?.filter(sample => sampleIds.includes(sample.id));              
            }             

            setInitialValues((prevInitialValues) => {

                const formValues = formikRef.current?.values || {}; // Safely access form values

                const updatedPrevInitialValues = Object.keys(prevInitialValues).reduce((acc, key) => {
                    acc[key] = formValues[key] !== undefined ? formValues[key] : prevInitialValues[key];
                    return acc;
                }, {});

                const updatedFields = selectedSamples.reduce((acc, sample) => {
                    acc[`expiration_date_${sample.id}`] = formValues[`expiration_date_${sample.id}`] || updatedPrevInitialValues[`expiration_date_${sample.id}`] || '';
                    acc[`unprocess_number_${sample.id}`] = formValues[`unprocess_number_${sample.id}`] || updatedPrevInitialValues[`unprocess_number_${sample.id}`] || '';
                    acc[`unprocess_unit_${sample.id}`] = formValues[`unprocess_unit_${sample.id}`] || updatedPrevInitialValues[`unprocess_unit_${sample.id}`] || 'mins';
                    acc[`is_fasting_${sample.id}`] = formValues[`is_fasting_${sample.id}`] || updatedPrevInitialValues[`is_fasting_${sample.id}`] || '';
                    acc[`fasting_duration_${sample.id}`] = formValues[`fasting_duration_${sample.id}`] || updatedPrevInitialValues[`fasting_duration_${sample.id}`] || '';
                    acc[`fasting_duration_unit_${sample.id}`] = formValues[`fasting_duration_unit_${sample.id}`] || updatedPrevInitialValues[`fasting_duration_unit_${sample.id}`] || 'hours';
                    acc[`is_special_donor_${sample.id}`] = formValues[`is_special_donor_${sample.id}`] || updatedPrevInitialValues[`is_special_donor_${sample.id}`] || '';
                    acc[`special_donors_${sample.id}`] = formValues[`special_donors_${sample.id}`] || updatedPrevInitialValues[`special_donors_${sample.id}`] || [];
                    acc[`instruction_${sample.id}`] = formValues[`instruction_${sample.id}`] || updatedPrevInitialValues[`instruction_${sample.id}`] || '';
                    return acc;
                }, {});

                const customUpdatedFields = filteredSampleFields.reduce((acc, fields) => {
                    fields.groups.forEach(group => {
                        const groupId = group.identifier;
                        if (Array.isArray(groupCheck) && groupCheck.includes(groupId)) {
                            const volumes = groupTotal[groupId] || {};
                            const totalVolume = Object.values(volumes).reduce((sum, value) => sum + (parseFloat(value) || 0), 0);

                            if (totalVolume === 0) {
                                setCustomFieldError(prevErrors => ({
                                    ...prevErrors,
                                    [groupId]: 'Please select amount per volunteer per day',
                                }));
                            } 
                        }
                        group.group_col.forEach(col => {
                            col.fields.forEach(field => {
                                // Add field values to accumulator
                                acc[field.name] = formValues[field.name] || updatedPrevInitialValues[field.name] || '';
                            });
                        });
                    });
                    return acc;
                }, {});

                return {
                    ...updatedPrevInitialValues, // Updated with form values
                    ...updatedFields,            // Add or update dynamic sample fields
                    ...customUpdatedFields       // Add or update dynamic sample custom fields
                };

            });
            
            const updatedValidationSchema = Yup.object().shape({
                ...staticValidationSchema.fields,
                ...selectedSamples.reduce((acc, sample) => {
                    const sampleId = sample.id;

                    acc[`expiration_date_${sampleId}`] = Yup.date()
                        .transform((value, originalValue) => {
                            if (originalValue) {
                                const formattedDate = format(originalValue, dateFormat);
                                const parsedDate = parse(formattedDate, dateFormat, new Date());
                                return isValid(parsedDate) ? parsedDate : new Date('');
                            }
                            return value;
                        })
                        .typeError('Please select a valid date from the DatePicker')
                        .required('Expiration date is required')
                        .test('is-not-less-than-scheduled', 'Your sample expiration date can not precede your sample pickup date. Please correct this above.', function (value) {
                            const { scheduled_pickup } = this.parent;
                            const scheduledPickupDate = scheduled_pickup ? new Date(scheduled_pickup.scheduledDate) : null;
                            const expirationDate = new Date(value);

                            if (scheduledPickupDate && expirationDate && expirationDate < scheduledPickupDate) {
                                return this.createError({
                                    message: 'Your sample expiration date can not precede your sample pickup date. Please correct this above.',
                                });
                            }
                            return true;
                        });

                    acc[`unprocess_number_${sampleId}`] = Yup.number()
                        .typeError('Unprocess number is required')
                        .required('Unprocess number is required')
                        .positive('Must be a positive number')
                        .min(1, 'Value must be greater than 0')
                        .integer('Must be an integer');

                    acc[`unprocess_unit_${sampleId}`] = Yup.string()
                        .required('Unprocess unit is required')
                        .oneOf(['mins', 'hours'], 'Invalid unit');

                    acc[`is_fasting_${sampleId}`] = Yup.string()
                        .required('This field is required');

                    acc[`fasting_duration_${sampleId}`] = Yup.number().when(`is_fasting_${sampleId}`, {
                        is: (value) => value === 'Yes',
                        then: (schema) => schema.required('This field is required').min(1, 'Value must be greater than 0'),
                        otherwise: (schema) => schema.notRequired(),
                    });

                    acc[`fasting_duration_unit_${sampleId}`] = Yup.string().when(`is_fasting_${sampleId}`, {
                        is: (value) => value === 'Yes',
                        then: (schema) => schema.required('This field is required'),
                        otherwise: (schema) => schema.notRequired(),
                    });

                    acc[`is_special_donor_${sampleId}`] = Yup.string().when('matched_sample', {
                        is: (value) => {
                            return value === 'No' || value === '' || typeof value === 'undefined';                            
                        },
                        then: (schema) => schema.required('This field is required'),
                        otherwise: (schema) => schema.notRequired(),
                    }).test(
                        `is-special-donor-${sampleId}-validation`,
                        `Special donor IDs for sample cannot be empty`,
                        function (value) {   
                            const specialDonors = this.parent[`special_donors_${sampleId}`];
                            const donorDemographicsData = this.parent[`special_donor_donorDemographicsData_${sampleId}`];
                            const matched_sample = this.parent['matched_sample'];

                            if (matched_sample === 'No' || matched_sample === '' || typeof matched_sample === 'undefined'){
                                if(value === 'No'){
                                    return true;
                                } else if(value === 'Yes'){
                                    if((!specialDonors || specialDonors.length === 0) && ( !donorDemographicsData || donorDemographicsData.length === 0)){
                                        return false;
                                    }
                                    return true; 
                                }
                            } 

                            return true;
                        }
                    );

                    acc[`instruction_${sampleId}`] = Yup.string()
                        .matches(/^[a-zA-Z0-9 ]*$/, 'Only alphanumeric characters are allowed');

                    // Ensure acc is returned after each iteration
                    return acc;
                }, {}),
                ...filteredSampleFields.reduce((acc, fields) => {

                    fields.groups.flatMap(group =>
                        group.group_col.flatMap(col =>
                            col.fields.map(({ name, type_text, required }) => {

                                let dependentField = (name === 'bloodfingerpricknote') ? 'bloodfingerpricktype' : (name.includes("numberoftubes")) ? name.replace("numberoftubes", "type") : null;

                                if (dependentField) {
                                    if(type_text == 'Number') {
                                        acc[name] = Yup.number().when(dependentField, {
                                            is: (value) => !!value,
                                            then: (schema) =>   schema.required('This field is required').min(1, 'Value must be greater than 0').integer('Must be an integer'),
                                            otherwise: (schema) => schema.notRequired(),
                                        });
                                    } else if (validTypes.includes(type_text)) {
                                        acc[name] = Yup.string().when(dependentField, {
                                            is: (value) => !!value,
                                            then: (schema) =>   schema.required('This field is required'),
                                            otherwise: (schema) => schema.notRequired(),
                                        });
                                    }
                                } else {

                                    const baseValidation = type_text === 'Number' ? Yup.number().required('This field is required') : validTypes.includes(type_text) ? Yup.string().required('This field is required') : null;
                                    if (baseValidation) {
                                        acc[name] = baseValidation;
                                    }
                                }
                            })
                        )
                    );
                    return acc;

                }, {})
            });

            setValidationSchema(updatedValidationSchema);
        }
    }, [selectedSamples]);

    useEffect(() => {
        setMinStartDate(new Date());
        fetchLabs();
        fetchParentStudy();
        fetchCustomFields();
        fetchSamplePickupWRTSampleCountList();
        setValidationSchema(staticValidationSchema);        
        
    }, []);
    
    useEffect(()=>{ 
        fetchDurationCompensationAppointment();
    },[selectedLab]);

    /** 
     * Handle Toggle Content Boxes
    */
    useEffect(() => {
        setLoading(true);
        RequestorService.getRequestorDetails(requestorId)
            .then(response => {

                const data = response.data.user;

                setRequestorData({
                    id: data.id,
                    display_name: data.display_name,
                    first_name: data.first_name,
                    middle_name: data.middle_name,
                    last_name: data.last_name,
                    username: data.username || '',
                    email: data.email || '',
                    phone_number: data.phone_number,
                    office_number: data.office_number,
                    gender: data.gender,
                    sequence: data.sequence,
                    lab_id: data.labs.id,
                    active: data.active,
                    role_name: "Requestor"
                    // password: '',  
                    // confirm_password: ''
                });

            })
            .catch(error => {
                console.log("Error fetching requestor details:", error);
            }).finally(() => {
                setLoading(false);
            });
    }, [requestorId]);

    const toggleCollapseBox = (index, event) => {

        const box = boxRefs.current[index];
        const icon = event.currentTarget.querySelector('i');

        if (box) {
            box.classList.toggle('open');
        }

        if (icon.classList.contains('el-icon-down')) {
            icon.classList.remove('el-icon-down');
            icon.classList.add('el-icon-up');
        } else {
            icon.classList.remove('el-icon-up');
            icon.classList.add('el-icon-down');
        }
    };


    /**
     * Handle Decimal Number
     */
    const handleDecimalNumber = (event) => {
        if (event.key === '.' || event.key ==="-"  || event.key ==="+" ) {
            event.preventDefault();
        } 
    };

    const toggleSampleDropdown = (e) => { 
        e.preventDefault();
        setIsOpen(prevState => !prevState); 

        if(isOpen == false && !sampleRequestDetails) {
            setLoading(true);
            fetchSampleTypes(); //called at top of code 
        } 
    };

    const handleSampleChange = (setFieldValue, id, checked) => {
        
        setSelectedSampleIds(prevState => {
            const updatedSampleIds = {
                ...prevState,
                [id]: !prevState[id], 
            };
            return updatedSampleIds;
        });
            

        /*if(!checked) {
            setSelectedSampleIds(updatedSampleIds);
        }*/

        let updatedSampleTypes = {
            ...selectedSampleIds,
            [id]: !selectedSampleIds[id],
        };

        if (checked == true && id) {
            delete updatedSampleTypes[id]; 
        }

        updatedSampleTypes = Object.fromEntries(
            Object.entries(updatedSampleTypes).filter(([_, value]) => value)
        );    
        
        setFieldValue("sample_types", updatedSampleTypes); 
    };

    useEffect(()=>{ 
        console.log("selectedSampleIds", selectedSampleIds);
    },[selectedSampleIds]);

    const handleSampleClose = () => {
        setIsOpen(false);
    };

    const handleRemovalOfIntialValues = (sampleId) => {

        let fetchValues = formikRef.current?.values;
        let filteredInitializeValues = Object.keys(fetchValues)
            .filter(key => !key.includes(`_${sampleId}`))
            .reduce((acc, key) => { acc[key] = fetchValues[key]; return acc; }, {});

        if (filteredInitializeValues.sample_types && filteredInitializeValues.sample_types[sampleId]) {
            const newSampleTypes = { ...filteredInitializeValues.sample_types };             
            delete newSampleTypes[sampleId];
            filteredInitializeValues.sample_types = newSampleTypes;
        }

        filteredInitializeValues = handleRemovalOfCustomFields(sampleId, filteredInitializeValues);
        setInitialValues({ ...filteredInitializeValues });

    }

    const handleRemovalOfCustomFields = (sampleId, filteredInitializeValues) => {

        if (Array.isArray(sampleFields)) {
            const sampleRemoveFields = sampleFields?.find(sample => sample.id == Number(sampleId));

            sampleRemoveFields.groups.flatMap(group =>
                group.group_col.flatMap(col =>
                    col.fields.map(field => {
                        const fieldName = field.name;
                        if (filteredInitializeValues.hasOwnProperty(fieldName)) {
                            delete filteredInitializeValues[fieldName];
                        }
                    })
                )
            );
        }

        return filteredInitializeValues;
    }

    const handleRemoval = (selectedIds, updatedData, sample = '') => {
        Object.keys(updatedData).forEach(sampleId => {
            if (!selectedIds.includes(Number(sampleId))) {
                delete updatedData[sampleId];
                if (sample) {
                    handleRemovalOfIntialValues(sampleId);
                }
            }
        });
    }

    const handleSampleRemovalAction = (sampleId) => {

        const updatedSelectedSampleIds = { ...selectedSampleIds };
        delete updatedSelectedSampleIds[sampleId];
        setSelectedSampleIds(updatedSelectedSampleIds);
        formikRef.current.setFieldValue("sample_types", updatedSelectedSampleIds); 

        const updatedSelectedSamples = Object.values(selectedSamples).filter(sample => sample.id !== sampleId);
        setSelectedSamples(updatedSelectedSamples);

        const updatedSampleRequest = { ...sampleRequest };
        delete updatedSampleRequest[sampleId];
        setSampleRequest(updatedSampleRequest);

        const updatedSampleDonors = { ...sampleSelectedDonor };
        delete updatedSampleDonors[sampleId];
        setSampleSelectedDonor(updatedSampleDonors);

        handleRemovalOfIntialValues(sampleId);

        //Remove Custom Field arrays

        let filteredSampleFields = [];
        if (Array.isArray(sampleFields)) {
            filteredSampleFields = sampleFields?.filter(sample => sample.id === sampleId);
            const groupIds = filteredSampleFields.flatMap(sample =>
                sample.groups.map(group => group.identifier)
            );

            if (Object.keys(customFieldError).length > 0) {
                const filteredErrors = Object.fromEntries(
                    Object.entries(customFieldError).filter(([key]) => !groupIds.includes(key)) // Negate the condition
                );
                setCustomFieldError(filteredErrors);
            }

            if (Object.keys(groupTotal).length > 0) {
                const filteredGroupTotal = Object.fromEntries(
                    Object.entries(groupTotal).filter(([key]) => !groupIds.includes(key)) // Negate the condition
                );
                setGroupTotal(filteredGroupTotal);
            }
        }

        if(sampleId == 1) {
            setBloodVolume(0);
        }

    }

    const handleSampleBulkRemovalAction = (sampleIds) => {
        // Filter and update selectedSampleIds
        const updatedSelectedSampleIds = { ...selectedSampleIds };
        sampleIds.forEach(sampleId => delete updatedSelectedSampleIds[sampleId]);
        setSelectedSampleIds(updatedSelectedSampleIds);
    
        // Filter and update selectedSamples
        const updatedSelectedSamples = Object.values(selectedSamples).filter(sample => !sampleIds.includes(sample.id));
        setSelectedSamples(updatedSelectedSamples);
    
        // Filter and update sampleRequest
        const updatedSampleRequest = { ...sampleRequest };
        sampleIds.forEach(sampleId => delete updatedSampleRequest[sampleId]);
        setSampleRequest(updatedSampleRequest);
    
        // Filter and update sampleSelectedDonor
        const updatedSampleDonors = { ...sampleSelectedDonor };
        sampleIds.forEach(sampleId => delete updatedSampleDonors[sampleId]);
        setSampleSelectedDonor(updatedSampleDonors);
    
        // Remove initial values in bulk
        handleBulkRemovalOfIntialValues(sampleIds);
    
        // Remove custom field arrays
        let groupIdsToRemove = [];
        if (Array.isArray(sampleFields)) {
            const filteredSampleFields = sampleFields.filter(sample => sampleIds.includes(sample.id));
            groupIdsToRemove = filteredSampleFields.flatMap(sample =>
                sample.groups.map(group => group.identifier)
            );
        }
        
        // Remove custom field errors
        if (Object.keys(customFieldError).length > 0) {
            const filteredErrors = Object.fromEntries(
                Object.entries(customFieldError).filter(([key]) => !groupIdsToRemove.includes(key))
            );
            setCustomFieldError(filteredErrors);
        }

        // Remove Group Total
        if (Object.keys(groupTotal).length > 0) {
            const filteredGroupTotal = Object.fromEntries(
                Object.entries(groupTotal).filter(([key]) => !groupIdsToRemove.includes(key))
            );
            setGroupTotal(filteredGroupTotal);
        }

        if(sampleIds.includes(1)) {
            setBloodVolume(0);
        }
    };

    const handleBulkRemovalOfIntialValues = (sampleIds) => {
        let fetchValues = formikRef.current?.values || {};
    
        // Filter out all keys related to the sampleIds
        let filteredInitializeValues = Object.keys(fetchValues)
            .filter(key => !sampleIds.some(sampleId => key.includes(`_${sampleId}`)))
            .reduce((acc, key) => {
                acc[key] = fetchValues[key];
                return acc;
            }, {});
    
        // Remove sample_types for all sampleIds
        if (filteredInitializeValues.sample_types) {
            const newSampleTypes = { ...filteredInitializeValues.sample_types };
            sampleIds.forEach(sampleId => {
                if (newSampleTypes[sampleId]) {
                    delete newSampleTypes[sampleId];
                }
            });
            filteredInitializeValues.sample_types = newSampleTypes;
        }
    
        // Handle removal of custom fields for all sampleIds
        filteredInitializeValues = handleBulkRemovalOfCustomFields(sampleIds, filteredInitializeValues);
    
        // Set the updated initial values
        setInitialValues({ ...filteredInitializeValues });
    };

    const handleBulkRemovalOfCustomFields = (sampleIds, filteredInitializeValues) => {
        if (Array.isArray(sampleFields)) {
            sampleIds.forEach(sampleId => {
                const sampleRemoveFields = sampleFields.find(sample => sample.id == Number(sampleId));
                if (sampleRemoveFields) {
                    sampleRemoveFields.groups.flatMap(group =>
                        group.group_col.flatMap(col =>
                            col.fields.forEach(field => {
                                const fieldName = field.name;
                                if (filteredInitializeValues.hasOwnProperty(fieldName)) {
                                    delete filteredInitializeValues[fieldName];
                                }
                            })
                        )
                    );
                }
            });
        }
    
        return filteredInitializeValues;
    };
    

    const handleSampleApply = () => {
        if(samples.length > 0){
            let deletedSampleIds = [];
            const isAnySelected = Object.values(selectedSampleIds).some(value => value);
            
            if (!isAnySelected) {
                setSampleTypeError('Please select at least one sample type.');
                return;
            }
            else {
                setSampleTypeError('');
            }

            const selectedIds = Object.keys(selectedSampleIds).filter(id => selectedSampleIds[id]).map(Number);
            const sampleDetails = samples?.filter(sample => selectedIds.includes(sample.id));
            const updatedSampleRequest = { ...sampleRequest };
            const updatedSampleDonorIds = { ...sampleSelectedDonor };
            const newlyAdded = selectedIds.filter((id) => !(id in sampleRequest));


            deletedSampleIds = Object.keys(selectedSampleIds)
            .filter((id) => selectedSampleIds[id] === false)
            .map(Number);


            sampleDetails.forEach(sample => {
                updatedSampleRequest[sample.id] = updatedSampleRequest[sample.id] || {
                    expiration_date: null,
                    unprocess_number: "",
                    unprocess_unit: "mins",
                    is_fasting: "",
                    fasting_duration: "",
                    fasting_duration_unit: "hours", //CH added for view details fasting_duration_unit label
                    instruction: "",
                    is_special_donor: "",
                    "special_donor": {
                        "preferred_donor": {
                            "donor_ids": [],
                            // "quantity": [],
                            // "gender": [],
                            // "female_qty": 0,
                            // "male_qty": 0
                        },
                        // "alternate_donor": {
                        //     "donor_ids": [],
                        //     "quantity": [],
                        //     "gender": [],
                        //     "female_qty": 0,
                        //     "male_qty": 0
                        // }
                    },
                    selected_donor_ids: [],
                    options: {
                    }
                };
                updatedSampleDonorIds[sample.id] = updatedSampleDonorIds[sample.id] || {
                    ids: []
                };
            });
        

            handleRemoval(selectedIds, updatedSampleRequest, 'sample');
            handleRemoval(selectedIds, updatedSampleDonorIds);

            if(deletedSampleIds.length > 0) {
                handleSampleBulkRemovalAction(deletedSampleIds);
            }

            setSampleRequest(updatedSampleRequest);
            setSampleSelectedDonor(updatedSampleDonorIds);
            setSelectedSamples(sampleDetails);
            setIsOpen(false);

            if(deletedSampleIds.length > 0 || newlyAdded.length > 0) {
                resetSampleRequestDonor();
            }
            
        }
    };

    const handleSampleFieldChange = (setFieldValue, field, value, sampleId = 0) => {
        // setFieldValue("scheduled_pickup", ""); // Reset scheduled_pickup
        if (sampleId) {
            const updatedSampleRequest = { ...sampleRequest };

            if (updatedSampleRequest[sampleId]) {
                updatedSampleRequest[sampleId][field] = value;
            } else {
                updatedSampleRequest[sampleId] = { [field]: value };
            }

            if (field == 'is_special_donor' && value == 'No') {
                updatedSampleRequest[sampleId].special_donor = resetSpecialDonor();
                updatedSampleRequest[sampleId].selected_donor_ids = [];
          
            }
            if((field == 'is_special_donor' && value == 'No' ) || ( field == "matched_sample" && value == 'No' ) ){//CH
           
                setFieldValue(`special_donors_${sampleId}`,[]);
                setFieldValue(`special_donor_donorDemographicsData_${sampleId}`,[]);   
                                 
                setFieldValue("special_donors",[]);
                setFieldValue("special_donor_donorDemographicsData",[]);
            }
            setSampleRequest(updatedSampleRequest);
            setFieldValue(`${field}_${sampleId}`, value);


        } else {
            setFieldValue(`${field}`, value);
            switch (field) {
                case 'matched_sample': setSampleMatched(value === 'Yes'); break;
                case 'is_special_donor': setSpecialDonorField(value === 'Yes'); break;
            }
            if(field == "matched_sample" && value == 'No'){//CH
                setFieldValue("is_special_donor","");
            }
            if(field == "matched_sample" || field == "is_special_donor"){//CH
                setFieldValue("special_donors",[]);
                setFieldValue("special_donor_donorDemographicsData",[]);

                const updatedSampleRequest = { ...sampleRequest };
                Object.keys(updatedSampleRequest).forEach((key) => {
                    updatedSampleRequest[key].special_donor = resetSpecialDonor();
                    updatedSampleRequest[key].selected_donor_ids = [];
                    setFieldValue(`is_special_donor_${key}`,"");
                    setFieldValue(`special_donors_${key}`,[]);
                    setFieldValue(`special_donor_donorDemographicsData_${key}`,[]);
                });
            }

        }

    };

    const fetchLabs = async () => {
        try {
            const response = await LabsService.getLabList();
            setLabs(response.labs || []);
        } catch (error) {
            console.error("Error fetching labs", error);
        }
    };

    const fetchParentStudy = async () => {
        try {   
            const payload ={
                user_id: requestorId
            }
            const response = await RequestorService.getParentStudies(payload);
            setParentStudy(response.data || []);
        } catch (error) {
            console.error("Error fetching labs", error);
        }
    };

    const [pickupDaysAvailableWRTSampleCount, setPickupDaysAvailableWRTSampleCount] = useState([]); // Initialize as an empty array
    const fetchSamplePickupWRTSampleCountList = async () => {
        try {

            // if(selectedSamples != null && selectedSamples.length>0){

            const sample_countt = {
                // count: selectedSamples.length
            }
            SampleRequestService.getPickupListDetails(sample_countt)
                .then(data => {
                    if (data.success) {
                        setPickupDaysAvailableWRTSampleCount(data.pickup);
                    }
                })   
                .catch((err) => {
                    console.error("Error fetching sample type data:", err);
                    setToastMessage(err.message);
                    setToastVariant('error');
                    setShowToast(true);
                    setLoading(false);
                });
            // }
        }
        catch (error) { console.error("Error fetching sample pickup schedule with respect to sample count", error); }
    }


    const [durationCompensationAppointment, setDurationCompensationAppointment] = useState([]);
    const [totalDuration, setTotalDuration] = useState(0);
    const [bloodVolume, setBloodVolume] = useState(0); // 0 -> 100 5 mins, 100 - 200 10 mins

    useEffect(() => {
        console.log("bloodVolume", bloodVolume);
    }, [bloodVolume]);
    const fetchDurationCompensationAppointment = async () => {
        try {
            const params = {
                lab_id: selectedLab
            }            
            const durationDetails = await SampleRequestService.getCompensationAndAppointmentDuationDetails(params);
            setDurationCompensationAppointment(durationDetails.data);
        }
        catch {

        }
    };


    // Function to get the duration for a specific sample based on conditions (e.g., ranges for blood volume)
    const getDurationForSample = (sampleId) => {        
        if (sampleId === 1) { // Assuming 1 is for Blood            
            // Filter all entries for blood and find the one matching the blood volume
            const bloodEntries = durationCompensationAppointment?.filter(item => item.sample_id === 1);
            const matchedEntry = bloodEntries?.find(entry =>
                bloodVolume >= entry.from_range && bloodVolume <= entry.to_range
            );
            return matchedEntry ? parseInt(matchedEntry.duration) : 0;
        } else {
            // For other samples, just return their duration directly
            const sampleEntry = durationCompensationAppointment?.find(item => item.sample_id === sampleId);
            return sampleEntry ? parseInt(sampleEntry.duration) : 0;
        }
    };

    // Calculate total duration based on selected sample IDs
    useEffect(() => { 
     
        if(durationCompensationAppointment?.length> 0){
            if(selectedSampleIds){

                const selectedIds = Object.keys(selectedSampleIds).filter((id) => selectedSampleIds[id]);
                const total = selectedIds.reduce((sum, id) => {
                    const duration = getDurationForSample(parseInt(id));
                    return sum + (duration || 0);
                }, 0);
                setTotalDuration(total * voluenteers); // Multiply by volunteers
            }
            
            formikRef.current.setFieldValue("scheduled_pickup", ""); // reset shceduled_pickup when sample type changed either added or deleted
        }
    }, [ durationCompensationAppointment, selectedSampleIds, voluenteers, bloodVolume]);

    const fetchSampleTypes = async () => {
        try {
            const samples = await SampleService.getSampleTypes();
            setSamples(samples.name || {});
            setLoading(false);
        } catch (error) {
            setSamples({});
            console.error("Error fetching sample types", error);
        }
    }

    const fetchCustomFields = async (params) => {
        try {
            const response = await SampleService.sampleCustomFields(params);
            setSampleFields(response.fields || []);
        } catch (error) {
            console.error("Error fetching labs", error);
        }
    };

    function getFieldsBySampleId(sampleId) {
        if (Array.isArray(sampleFields) && sampleId) {
            return sampleFields?.filter(sample => sample.id === sampleId);
        }

        return [];
    }

    const handleFieldTouched = (setTouched) => {

        if (selectedSamples.length > 0) {
            selectedSamples.forEach(sample => {
                setTouched({
                    [`expiration_date_${sample.id}`]: true,
                    [`unprocess_number_${sample.id}`]: true,
                    [`unprocess_unit_${sample.id}`]: true,
                    [`is_fasting_${sample.id}`]: true,
                    [`fasting_duration_${sample.id}`]: true,
                    [`fasting_duration_unit_${sample.id}`]: true,
                    [`is_special_donor_${sample.id}`]: true,
                    [`instruction_${sample.id}`]: true
                });
            });
        }
    };
    
    const transformSpecialDonor = (specialDonor) => {
        const transformDonor = (donor = {}) => {
            // const genders = [];
            // const quantities = [];
    
            // if (donor.gender?.includes("male")  || donor.gender?.includes("XY") ) {
            //     genders.push("XY");
            //     quantities.push(donor.male_qty ); // Add quantity for male if available
            // }
            // // ?? null
            // if (donor.gender?.includes("female") || donor.gender?.includes("XX")) {
            //     genders.push("XX");
            //     quantities.push(donor.female_qty); // Add quantity for female if available
            // }
            // ?? null
    
            // If no quantity is available, set it to null
            // if (quantities.length === 0) {
            //     quantities.push(null);
            // }
    
            return {
                donor_ids: donor.donor_ids || [],
                demographics : donor.donorDemographicsData
                // quantity: quantities,
                // gender: genders,
            };
        };
    
        return {
            special_donor: {
                preferred_donor: transformDonor(specialDonor?.preferred_donor),
                // alternate_donor: transformDonor(specialDonor?.alternate_donor),
            },
        };
    };
    
    const transformSampleRequest = (sampleRequest) => {
        const transformedSampleRequest = {};

        Object.keys(sampleRequest).forEach((key) => {
            const sample = sampleRequest[key];
            if (sample) {
                transformedSampleRequest[key] = {
                    expiration_date: sample.expiration_date
                        ? new Date(sample.expiration_date).toLocaleDateString("en-US", {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                        })
                        : null,
                    unprocess_number: parseInt(sample.unprocess_number, 10) || null,
                    unprocess_unit: sample.unprocess_unit || null,
                    is_fasting: sample.is_fasting.toLowerCase() || "no",
                    fasting_duration: parseInt(sample.fasting_duration, 10) || null,
                    fasting_unit: sample.fasting_duration_unit ? sample.fasting_duration_unit : sample.is_fasting.toLowerCase() == "yes" ? "hours" : null,
                    instruction: sample.instruction || null,
                    is_special_donor: sample.is_special_donor.toLowerCase() || "no",
                    // selected_donor_ids: sample.selected_donor_ids || [],
                    special_donor:  sample.is_special_donor.toLowerCase() === "yes" ? transformSpecialDonor(sample.special_donor).special_donor : "",
                    options: sample.options || {}, // Keep options as is
                };
            }
        });

        return transformedSampleRequest;
    };


    const handleSubmit = async (values, draft) => {     
        try {
            setLoading(true);
            // const transformedSpecialDonor = transformSpecialDonor(values.special_donor);
            const transformedSpecialDonor = transformSpecialDonor(specialDonor.special_donor);
            const transformedSampleRequest = transformSampleRequest(sampleRequest);
            const sampleRequestPayload = {
                lab_id: values.lab_id,
                requestor_id: values.requestor_id,
                project_name: values.project_name,
                wbs_reference: values.wbs_element,

                is_partof_parent_study: values.is_partof_parent_study.toLowerCase(),
                parent_study_id: values.parent_study_id,
                exclude_parent_study_donors : values.exclude_parent_study_donors.toLowerCase(), 

                no_of_volunteers: values.volunteers,
                smoker_allowed: values.smoker_allowed.toLowerCase(),
                herbal_vitamins: values.vitamins_herbal_allowed.toLowerCase(),
                herbal_vitamins_note: values.last_does_vitamins,
                medication_allowed: values.all_medication_allowed.toLowerCase(),
                medications_note: values.excluded_medication,
                donor_restriction: values.donor_restriction,
                // age_from: values.age_from,
                // age_to: values.age_to,
                matched_samples: values.matched_sample.toLowerCase(),
                is_special_donor: values.is_special_donor ? values.is_special_donor.toLowerCase() : 'no',
                special_donor:  values.is_special_donor === "Yes" ? transformedSpecialDonor.special_donor  : "",
                is_exclude_donor: values.is_exclude_donor ? values.is_exclude_donor.toLowerCase() : 'no',
                exclude_donor_ids: excludedDonorIds,
                // sample_ids: [1,2],
                sample_ids: Object.keys(selectedSampleIds || {})
                    .filter((key) => selectedSampleIds[key])
                    .map((key) => parseInt(key)),
                sample_request: transformedSampleRequest, //this transforms data to requred form and adds options as of now for blood and urine
                // sample_request: sampleRequest, // this is working but gets sampleRequest as it is.
                sample_collect_duration: `${totalDuration} mins`,
                schedule_pickup_date: values.scheduled_pickup?.scheduledDate,
                schedule_pickup_time: values.scheduled_pickup?.selectedTime,
                request_initial: values.initial,
                is_draft: draft == true ? 'yes' : 'no',
                total_volume: groupTotal
            };
            if (requestId) {
                sampleRequestPayload.request_id = requestId;
            }
     
            if(requestId){
              
                //update SR for drafted/ duplicated SR
                SampleService.updateSampleRequest(sampleRequestPayload)
                    .then(response => {
                        console.log('Sample request added successfully:', response);
                       
                        if (response.success) { 
                            if (showProfileSettingsModal) {
                                setToastMessage(response.message);
                                setToastVariant('success');
                                setNavigateToProfileSettings(true);
                                // navigate('/profile-management/profile-settings');
                            }
                            else {
                                setToastMessage(response.message);
                                setToastVariant('success');
                                setNavigateToSampleRequestList(true);
                            } 
                            setLoading(false);
                        }
                        else {
                            setShowToast(true);
                        
                            // Check if the response.message is an object
                            let formattedMessage = '';
                            if (typeof response.message === 'object' && response.message !== null) {
                                // Convert object to a readable string
                                formattedMessage = Object.keys(response.message)
                                    .map((key) => `${key}: ${response.message[key].join(', ')}`)
                                    .join(' | ');
                            } else {
                                // Use response.message directly if it's not an object
                                formattedMessage = response.message || 'An error occurred.';
                            }
                        
                            // if (showProfileSettingsModal) {
                            //     setToastMessage(formattedMessage);
                            //     setToastVariant('error');
                            //     setNavigateToProfileSettings(true);
                            //     // navigate('/profile-management/profile-settings');
                            // }
                            // else{ 
                                setToastMessage(formattedMessage);
                                setToastVariant('error');
                            // }
                            setLoading(false);
                        }
                        
                    })
                    .catch(error => {
                        console.error('Failed to add sample request:', error);
                        setLoading(false);
                    });
            }
            else{

                //add SR
                SampleService.addSampleRequest(sampleRequestPayload)
                    .then(response => {
                        console.log('Sample request added successfully:', response);
    
                        if (response.success) {
                            if (showProfileSettingsModal) {
                                setToastMessage('Sample request added successfully!');
                                setToastVariant('success');
                                setNavigateToProfileSettings(true);
                                // navigate('/profile-management/profile-settings');
                            }
                            else {
                                setToastMessage('Sample request added successfully!');
                                setToastVariant('success');
                                setNavigateToSampleRequestList(true);
                            }
                            setLoading(false);
                        }
                        else {
                            
                            setShowToast(true);
                        
                            // Check if the response.message is an object
                            let formattedMessage = '';
                            if (typeof response.message === 'object' && response.message !== null) {
                                // Convert object to a readable string
                                formattedMessage = Object.keys(response.message)
                                    .map((key) => `${key}: ${response.message[key].join(', ')}`)
                                    .join(' | ');
                            } else {
                                // Use response.message directly if it's not an object
                                formattedMessage = response.message || 'An error occurred.';
                            }
                            
                            // if (showProfileSettingsModal) {
                            //     setToastMessage(formattedMessage);
                            //     setToastVariant('error');
                            //     setNavigateToProfileSettings(true);
                            //     // navigate('/profile-management/profile-settings');
                            // }
                            // else{ 
                                setToastMessage(formattedMessage);
                                setToastVariant('error');
                            // }
                            setLoading(false);
                        }
                        
                    })
                    .catch(error => {
                        console.error('Failed to add sample request:', error);
                        setLoading(false);
                    });
                
            }
            
        } catch (error) {
            console.error("Error during form submission:", error);
            setLoading(false);
        }

    };

    // UseEffect to handle navigation
    useEffect(() => {
        if (navigateToSampleRequestList) {
            const timer = setTimeout(() => {
                navigate('/requestor/requestor-sample-requests', {
                    state: {
                        toastMessage: toastMessage,
                        toastVariant: toastVariant,
                    }
                },);
            },10);
            return () => clearTimeout(timer);
        }
    }, [navigateToSampleRequestList]);

    useEffect(() => {
        if (navigateToProfileSettings) {
            const timer = setTimeout(() => {
                navigate('/profile-management/profile-settings', {
                    state: {
                        toastMessage: toastMessage,
                        toastVariant: toastVariant,
                    }
                },);
            },);
            return () => clearTimeout(timer);
        }
    }, [navigateToProfileSettings]);

    const [showTrainingModal, setShowTrainingModal] = useState(false);
    const handleClosePickupModal = () => setShowTrainingModal(false);
    const [scheduleType, setScheduleType] = useState();
    const handleShowTrainingModal = (type) => {

        setShowTrainingModal(true);
        setScheduleType(type);
    }
    const confirmPickupModal = (values) => {
        formikRef.current.setFieldValue("scheduled_pickup", values);
        handleClosePickupModal();
    };


    const handleCloseTrainingModal = () => {
        setShowTrainingModal(false);

    }
    const volunteersRef = useRef(null);
    const labIdRef = useRef(null);
    const selectSampleRequestRef = useRef(null);
    const confirm_infoRef = useRef(null);


    const renderSpecialDonor = (setFieldValue, setSpecialDonor, specialDonor, selectedDonorIds, setSelectedDonorIds, sampleId, donorDemographicsDataFromDetailsUnmatched) => {
        console.log(sampleRequest)
        return (
            <>
                <SpecialDonor
                    selectedSampleIds={selectedSampleIds}
                    setSampleTypeError={setSampleTypeError}
                    donorType="preferred"
                    setFieldValue={setFieldValue}
                    elementRef={sampleRef}
                    specialDonor={specialDonor}
                    setSpecialDonor={setSpecialDonor}
                    selectedDonorIds={selectedDonorIds}
                    setSelectedDonorIds={setSelectedDonorIds}
                    excludedDonorIds={excludedDonorIds}
                    sampleId={sampleId}
                    activeField={activeField}
                    setActiveField={setActiveField}
                    donorDemographicsDataFromDetails={donorDemographicsDataFromDetails}
                    donorDemographicsDataFromDetailsUnmatched= {donorDemographicsDataFromDetailsUnmatched}
                />

                {/* <SpecialDonor
                    selectedSampleIds={selectedSampleIds}
                    setSampleTypeError={setSampleTypeError}
                    donorType="alternate"
                    setFieldValue={setFieldValue}
                    elementRef={sampleRef}
                    specialDonor={specialDonor}
                    setSpecialDonor={setSpecialDonor}
                    selectedDonorIds={selectedDonorIds}
                    setSelectedDonorIds={setSelectedDonorIds}
                    excludedDonorIds={excludedDonorIds}
                    sampleId={sampleId}
                    activeField={activeField}
                    setActiveField={setActiveField}
                /> */}
            </>
        );
    };

    const resetSampleRequestDonor = () => {
        setSampleRequest((prevSampleRequest) => {
            const updatedSampleRequest = Object.keys(prevSampleRequest).reduce((acc, key) => {
                acc[key] = {...prevSampleRequest[key], special_donor: resetSpecialDonor(), selected_donor_ids: []};
                formikRef.current.setFieldValue(`special_donors_${key}`, []);
                return acc;
            }, {});

            return updatedSampleRequest;
        });
        setSpecialDonor({special_donor: resetSpecialDonor()});
        formikRef.current.setFieldValue("special_donors", []);
    }


    return (
        <>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">
                         
                        {requestId ?
                            <> Edit Sample</>
                            : <>Request New Sample</>}
                    </h2>
                  
                    <Formik
                        innerRef={formikRef}
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        validateOnBlur={true}
                        validateOnChange={true}
                        enableReinitialize={true}                        
                        onSubmit={(values, { setTouched }) => {
                            handleFieldTouched(setTouched);
                            // handleSubmit(values);
                        }}
                    >
                        {({ values, setFieldValue, setFieldTouched, errors, touched, validateForm, isValid }) => {                                                      
                            const handleSchedulePickupClick = (e, type) => {
                                // e.preventDefault(); 
                                if (errors.volunteers) {
                                    volunteersRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });

                                    volunteersRef.current?.focus();
                                }
                                else if (values.lab_id == "") {  // or else do on type="submit"
                                    setFieldTouched("lab_id", true, true);// or else do on type="submit"
                                    labIdRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    labIdRef.current?.focus();
                                }
                                else if (sampleTypeError) {
                                    selectSampleRequestRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });

                                    selectSampleRequestRef.current?.focus();
                                }
                                else {
                                    handleShowTrainingModal(type);
                                }
                            };

                            const handleScrollUpOnSubmit = (validationErrors) => {                               
                                if (validationErrors) { 
                                    Object.keys(validationErrors).forEach((field) => {
                                        setFieldTouched(field, true, false);
                                    });
                                     //opening all closed accordions
                                    boxRefs.current.forEach((_, index) => {
                                        const box = boxRefs.current[index];
                                        const icon = box?.previousElementSibling?.querySelector('i'); 

                                        // Open the box if it's not open
                                        if (box && !box.classList.contains('open')) {
                                            box.classList.add('open');
                                        }

                                        // Change the icon if needed
                                        if (icon && icon.classList.contains('el-icon-down')) {
                                            icon.classList.remove('el-icon-down');
                                            icon.classList.add('el-icon-up');
                                        }
                                    });
                                    const firstErrorField = document.querySelector("[data-error='true']");
                                    if (firstErrorField) {
                                        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
                                        firstErrorField.focus();
                                    }
                                }
                            };
                            const handleScrollUpOnDraftSubmit = (validationErrors) => {  
                                                             
                                if (validationErrors) { 
                                    // Filter to include only errors for project_name and lab_id
                                    const draftErrors = Object.keys(validationErrors).reduce((acc, key) => {
                                        if (key === 'project_name' || key === 'lab_id') {
                                            acc[key] = validationErrors[key];
                                        }
                                        return acc;
                                    }, {});
                            
                                    // Mark these fields as touched
                                    Object.keys(draftErrors).forEach((field) => {
                                        setFieldTouched(field, true, false);
                                    });
                            
                                    // Open all closed accordions
                                    boxRefs.current.forEach((_, index) => {
                                        const box = boxRefs.current[index];
                                        const icon = box?.previousElementSibling?.querySelector('i'); 
                            
                                        // Open the box if it's not open
                                        if (box && !box.classList.contains('open')) {
                                            box.classList.add('open');
                                        }
                            
                                        // Change the icon if needed
                                        if (icon && icon.classList.contains('el-icon-down')) {
                                            icon.classList.remove('el-icon-down');
                                            icon.classList.add('el-icon-up');
                                        }
                                    });
                            
                                    // Find the first error field
                                    const firstErrorField = document.querySelector("[name='project_name'][data-error='true']") 
                                                          || document.querySelector("[name='lab_id'][data-error='true']");
                            
                                    if (firstErrorField) {
                                        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
                                        firstErrorField.focus();
                                    }
                                }
                            };
                            
                            
                            return (
                                <>
                                <Helmet>
                                    <title>DonorX | Request New Sample</title>
                                </Helmet>

                                <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Sample Requests</Link>

                                <Form className="sample-new-request el-bg-table mb-5 el-profile-board p-3 ely-sample-request-details mt-3"  autoComplete="off">
                                    {requestId && (
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <div> 
                                                    <h3><span className={'text-bg-warning badge'}> <i className="el-icon-dot mb-0"></i> {getStatusLabel(sampleRequestDetails?.request?.status, "requestor")}</span></h3>
                                                </div> 
                                                <div>
                                                    <Dropdown>
                                                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                                            <i className="el-icon-sort me-2"></i> Actions
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu className="el-admins">
                                                            <Dropdown.Item  
                                                                 onClick={async (e) => {
                                                                    const validationErrors = await validateForm();
            
                                                                    // Filter errors for project_name and lab_id
                                                                    const draftErrors = Object.keys(validationErrors).filter(
                                                                        (key) => key === 'project_name' || key === 'lab_id'
                                                                    );
            
                                                                    // Check if there are no errors in project_name and lab_id
                                                                    if (draftErrors.length === 0) {
                                                                        handleSubmit(values, true); // Call handleSubmit when there are no errors
                                                                    } else {
                                                                        handleScrollUpOnDraftSubmit(validationErrors); // Scroll to the errors
                                                                    }
                                                                }}>
                                                                Save For Later
                                                            </Dropdown.Item>
                                                            <Dropdown.Item onClick={()=>{handleDuplicateRequest(requestId)}}
                                                                >
                                                                Duplicate
                                                            </Dropdown.Item>
                                                            <Dropdown.Item onClick={()=>{handleDeleteRequest(requestId)}}>
                                                                Delete
                                                            </Dropdown.Item> 
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div> 
                                        </>
                                    )}
                                    {
                                        requestorData ? (
                                            <UserProfileDetails
                                                userType="request-new-sample"
                                                userData={requestorData}
                                                onCheckboxChange={(checked) => setFieldValue('confirm_info', checked)}
                                                value={values.confirm_info}
                                                error={errors.confirm_info}
                                                touched={touched.confirm_info}
                                                goToUserProfileSettings={goToUserProfileSettings}
                                            />
                                        ) : (<Loader loading={loading} />)
                                    }
                                    <div className="w-md-70">
                                    <div className="el-bg-table el-super-admin el-sr mb-4 mt-4 p-4 pb-1">
                                        <div className="el-bg-content-inner el-bg-content-inner-sr">
                                            <h3 className="el-title mt-1 mb-2">
                                                Project Details
                                            </h3>
                                            <button onClick={(e) => toggleCollapseBox(100, e)} className="el-bg-collapsable" type="button"><i className="el-icon-up"></i></button>
                                        </div>

                                        <div
                                            ref={(el) => (boxRefs.current[100] = el)}
                                            className="el-bg-collapsible-content el-bg-collapsible-content-sr open"
                                        >
                                            <div className="mt-4 row">
                                                {/* <div className="col-xl-12 mb-4">
                                                    <label htmlFor="lab_id" className="form-label">Lab<span className="text-red">*</span></label>
                                                    <Field
                                                        innerRef={labIdRef}
                                                        as="select"
                                                        name="lab_id"
                                                        className="form-control"
                                                        value={values.lab_id}
                                                        onChange={(e) => {
                                                            const selectedLab = e.target.value;
                                                            setFieldValue("lab_id", selectedLab);
                                                            setFieldValue("scheduled_pickup", ""); // Reset scheduled_pickup
                                                            setFieldTouched("lab_id", false);
                                                            setSelectedLab(selectedLab);
                                                        }}
                                                        data-error={errors["lab_id"] ? "true" : "false"}
                                                    >
                                                        <option value="">Select a Lab</option>
                                                        {labs.map((lab) => (
                                                            <option key={lab.id} value={lab.id}>{lab.name}</option>
                                                        ))}
                                                    </Field>
                                                    {touched['lab_id'] && errors['lab_id'] && (
                                                        <ErrorMessage name="lab_id" component="div" className="text-danger" />
                                                    )}
                                                </div> */}
                                                <div className="col-xl-12 mb-4">
                                                <label htmlFor="lab_id" className="form-label">
                                                    Lab<span className="text-red">*</span>
                                                </label>

                                                <Dropdown
                                                    onSelect={(selectedLab) => {
                                                    setFieldValue('lab_id', selectedLab);
                                                    setFieldValue('scheduled_pickup', ''); // Reset scheduled_pickup
                                                    setFieldTouched('lab_id', false);
                                                    setSelectedLab(selectedLab);
                                                    }}
                                                >
                                                    <Dropdown.Toggle
                                                   
                                                    id="dropdown-lab"
                                                    className="form-control d-flex justify-content-between align-items-center dropdown job-list-st-filter el-request-management-dropdown"
                                                    //   className={`form-control text-start ${
                                                    //     errors['lab_id'] && touched['lab_id'] ? 'is-invalid' : ''
                                                    //   }`}
                                                    >
                                                    {values.lab_id
                                                        ? labs.find((lab) => lab.id.toString() === values.lab_id.toString())?.name
                                                        : 'Select a Lab'}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item eventKey="">
                                                        Select a Lab
                                                        </Dropdown.Item>
                                                    {labs.map((lab) => (
                                                        <Dropdown.Item key={lab.id} eventKey={lab.id}>
                                                        {lab.name}
                                                        </Dropdown.Item>
                                                    ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>

                                                {touched['lab_id'] && errors['lab_id'] && (
                                                    <div className="text-danger">{errors['lab_id']}</div>
                                                )}
                                                </div>
                                                <div className="mb-2">
                                                    <div className="col-xl-12 radio-wrapper ">
                                                        <label htmlFor="lab_id" className="form-label position-unset my-0">Is this Request Part of Parent Study? <span className="text-red">*</span></label>
                                                        <div className="d-flex ">
                                                            {['Yes', 'No'].map((option) => (
                                                                <div className="form-check" key={option}>
                                                                    <Field id={`is_partof_parent_study_${option}`} type="radio" name="is_partof_parent_study" value={option} className="form-check-input" autoComplete="off" data-error={errors['is_partof_parent_study'] ? "true" : "false"} />
                                                                    <label className="form-check-label" htmlFor={`is_partof_parent_study_${option}`}>&nbsp; {option}</label>
                                                                </div>
                                                            ))}
                                                            
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {touched['is_partof_parent_study'] && errors['is_partof_parent_study'] && (
                                                            <ErrorMessage name="is_partof_parent_study" component="div" className="text-danger" />
                                                        )}
                                                    </div>
                                                 </div>
                                                  {/* {values.is_partof_parent_study === 'Yes' && (
                                                    <div className="col-xl-12 mb-4 radio-wrapper">
                                                        <label htmlFor="parent_study_id" className="form-label">Select parent study<span className="text-red">*</span></label>
                                                        <Field
                                                            innerRef={labIdRef}
                                                            as="select"
                                                            name="parent_study_id"
                                                            className="form-control"
                                                            value={values.parent_study_id}
                                                            onChange={(e) => {debugger
                                                                const selectedStudy = e.target.value;
                                                                setFieldValue("parent_study_id", selectedStudy);
                                                                setFieldTouched("parent_study_id", false);
                                                            }}
                                                            data-error={errors["parent_study_id"] ? "true" : "false"}
                                                        >
                                                            <option value="">Select a parent study</option>
                                                            {parentStudy.map((study) => (
                                                                <option key={study.id} value={study.id}>{study.title}</option>
                                                            ))}
                                                        </Field>
                                                        {touched['parent_study_id'] && errors['parent_study_id'] && (
                                                            <ErrorMessage name="parent_study_id" component="div" className="text-danger" />
                                                        )}
                                                    </div>
                                                  )} */}
                                                    {values.is_partof_parent_study === 'Yes' && (
                                                    <div className="col-xl-12 mb-2">
                                                        <label htmlFor="parent_study_id" className="form-label">
                                                        Select parent study <span className="text-red">*</span>
                                                        </label>

                                                        <Dropdown
                                                        onSelect={(selectedStudy) => {
                                                            setFieldValue('parent_study_id', selectedStudy);
                                                            setFieldTouched('parent_study_id', false);
                                                        }}
                                                        >
                                                        <Dropdown.Toggle 
                                                            id="dropdown-parent-study"
                                                            className={`form-control d-flex justify-content-between align-items-center job-list-st-filter el-request-management-dropdown ${
                                                            errors['parent_study_id'] && touched['parent_study_id'] ? 'is-invalid' : ''
                                                            }`}
                                                        >
                                                            {values.parent_study_id
                                                            ? parentStudy.find((study) => study.id.toString() === values.parent_study_id.toString())?.title
                                                            : 'Select a parent study'}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item eventKey="">Select a parent study</Dropdown.Item>
                                                            {parentStudy.map((study) => (
                                                            <Dropdown.Item key={study.id} eventKey={study.id}>
                                                                {study.title}
                                                            </Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                        </Dropdown>

                                                        {touched['parent_study_id'] && errors['parent_study_id'] && (
                                                        <div className="text-danger">{errors['parent_study_id']}</div>
                                                        )}
                                                    </div>
                                                    )}

                                                <div className="col-xl-12 mb-2 mb-xl-0">
                                                    <Autocomplete
                                                        name="project_name"
                                                        label="Project name"
                                                        placeholder="Type here to search..."
                                                        error={errors['project_name']}
                                                        touched={touched['project_name']}
                                                        value={values.project_name}
                                                        setFieldValue={setFieldValue}
                                                        allowInputChange="true"
                                                        isRequestDuplicate={sampleRequestDetails}
                                                        activeField={activeField}
                                                        setActiveField={setActiveField}
                                                    />
                                                </div>
                                                <div className="col-xl-12 mb-2 mb-xl-0">
                                                    <label htmlFor="wbs_element" className="form-label">WBS Element<span className="text-red">*</span></label>
                                                    <Field
                                                        type="text"
                                                        name="wbs_element"
                                                        placeholder="Type here"
                                                        className="form-control"
                                                        data-error={errors['wbs_element'] ? "true" : "false"}
                                                        autoComplete="off"
                                                    />
                                                    {touched['wbs_element'] && errors['wbs_element'] && (
                                                          <div className="error-placeholder">
                                                        <ErrorMessage name="wbs_element" component="div" className="text-danger" />
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="col-xl-12 mb-xl-0">
                                                    <label htmlFor="volunteers" className="form-label">Number of volunteers needed<span className="text-red">*</span></label>
                                                    <Field
                                                        type="number"
                                                        name="volunteers"
                                                        min="0"
                                                        className="form-control"
                                                        placeholder="Type here"
                                                        innerRef={volunteersRef}
                                                        onKeyDown={handleDecimalNumber}
                                                        value={values.volunteers}
                                                        autoComplete="off"
                                                        onChange={(e) => {
                                                            const newVolunteers = parseInt(e.target.value);
                                                            // || 1
                                                            setVoluenteers(newVolunteers);
                                                            setFieldValue("volunteers", newVolunteers);
                                                            setFieldValue("scheduled_pickup", "");
                                                        }}
                                                        data-error={errors['volunteers'] ? "true" : "false"}
                                                    />
                                                    {touched['volunteers'] && errors['volunteers'] && (
                                                        <ErrorMessage name="volunteers" component="div" className="text-danger" />
                                                    )}
                                                </div>
                                                {values.is_partof_parent_study === 'Yes' && (
                                                    <div className="col-xl-12 mt-4 radio-wrapper">
                                                        <label htmlFor="exclude_parent_study_donors" className="form-label-check">
                                                        Do you want to exclude all donors that have already participated in this Parent Study? <span className="text-red">*</span>
                                                        </label>
                                                        <div className="d-flex mt-1">
                                                        {['Yes', 'No'].map((option) => (
                                                            <div className="form-check" key={option}>
                                                            <Field
                                                                type="radio"
                                                                id={`exclude_parent_study_donors_${option}`}
                                                                name="exclude_parent_study_donors"
                                                                value={option}
                                                                className="form-check-input"
                                                                autoComplete="off"
                                                                data-error={errors.exclude_parent_study_donors ? "true" : "false"}
                                                            />
                                                            <label  htmlFor={`exclude_parent_study_donors_${option}`} className="form-check-label">&nbsp; {option}</label>
                                                            </div>
                                                        ))}
                                                        {touched.exclude_parent_study_donors && errors.exclude_parent_study_donors && (
                                                            <ErrorMessage name="exclude_parent_study_donors" component="div" className="text-danger" />
                                                        )}
                                                        </div>
                                                    </div>
                                                    )}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="el-bg-table el-super-admin el-sr mb-4 mt-4 p-4 pb-1">
                                        <div className="el-bg-content-inner el-bg-content-inner-sr">
                                            <h3 className="el-title mt-1 mb-2">
                                                General Requirement
                                            </h3>
                                            <button onClick={(e) => toggleCollapseBox(200, e)} className="el-bg-collapsable" type="button"><i className="el-icon-up"></i></button>
                                        </div>

                                        <div
                                            ref={(el) => (boxRefs.current[200] = el)}
                                            className="el-bg-collapsible-content el-bg-collapsible-content-sr open"
                                        >

                                            <div className="mt-4 row">
                                                <div className="mb-2">
                                                <div className="col-12  radio-wrapper">
                                                    <label htmlFor="smoker_allowed" className="form-label-check">Smokers Allowed?<span className="text-red">*</span></label>

                                                    <div className="d-flex mt-1">
                                                        {['Yes', 'No'].map((option) => (
                                                            <div className="form-check" key={option}>
                                                                <Field  id={`smoker_allowed_${option}`} type="radio" name="smoker_allowed" value={option} className="form-check-input" autoComplete="off" data-error={errors['smoker_allowed'] ? "true" : "false"} />
                                                                <label  htmlFor={`smoker_allowed_${option}`} className="form-check-label">&nbsp; {option}</label>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                                        {touched['smoker_allowed'] && errors['smoker_allowed'] && (
                                                            <ErrorMessage name="smoker_allowed" component="div" className="text-danger" />
                                                        )}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="mb-2">
                                                <div className="col-12 radio-wrapper">
                                                    <label htmlFor="vitamins_herbal_allowed" className="form-label-check">Vitamins & Herbal Supplements Allowed?<span className="text-red">*</span></label>

                                                    <div className="d-flex mt-1">
                                                        {['Yes', 'No'].map((option) => (
                                                            <div className="form-check" key={option}>
                                                                <Field id={`vitamins_herbal_allowed_${option}`}  type="radio" name="vitamins_herbal_allowed" value={option} className="form-check-input" autoComplete="off" data-error={errors['vitamins_herbal_allowed'] ? "true" : "false"} />
                                                                <label htmlFor={`vitamins_herbal_allowed_${option}`} className="form-check-label">&nbsp; {option}</label>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                                        {touched['vitamins_herbal_allowed'] && errors['vitamins_herbal_allowed'] && (
                                                            <ErrorMessage name="vitamins_herbal_allowed" component="div" className="text-danger" />
                                                        )}
                                                </div>

                                                {values.vitamins_herbal_allowed === 'No' && (
                                                    <div className="col-xl-12 mb-4">
                                                        <label htmlFor="last_does_vitamins" className="form-label">Minimum time since last dose of vitamins/supplements or medications<span className="text-red">*</span></label>
                                                        <Field
                                                            type="text"
                                                            placeholder="Type here"
                                                            name="last_does_vitamins"
                                                            className="form-control" autoComplete="off"
                                                            data-error={errors['last_does_vitamins'] ? "true" : "false"}
                                                        />
                                                        {touched['last_does_vitamins'] && errors['last_does_vitamins'] && (
                                                            <ErrorMessage name="last_does_vitamins" component="div" className="text-danger" />
                                                        )}
                                                    </div>
                                                )}

                                            </div>

                                            <div className="row">
                                                <div className="mb-2">
                                                <div className="col-12 radio-wrapper">
                                                    <label htmlFor="all_medication_allowed" className="form-label-check">All Medications Allowed?<span className="text-red">*</span></label>

                                                    <div className="d-flex mt-1">
                                                        {['Yes', 'No'].map((option) => (
                                                            <div className="form-check" key={option}>
                                                                <Field id={`all_medication_allowed_${option}`} type="radio" name="all_medication_allowed" value={option} className="form-check-input" autoComplete="off" data-error={errors['all_medication_allowed'] ? "true" : "false"} />
                                                                <label htmlFor={`all_medication_allowed_${option}`} className="form-check-label">&nbsp; {option}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                {touched['all_medication_allowed'] && errors['all_medication_allowed'] && (
                                                    <ErrorMessage name="all_medication_allowed" component="div" className="text-danger" />
                                                )}
                                                </div>

                                                 {values.all_medication_allowed === 'No' && (
                                                    <div className="col-xl-12 mb-4 mb-xl-0">
                                                        <label htmlFor="excluded_medication" className="form-label">If No, please list excluded medications<span className="text-red">*</span></label>
                                                        <Field
                                                            type="text"
                                                            placeholder="Type here"
                                                            name="excluded_medication"
                                                            id="excluded_medication"
                                                            className="form-control" autoComplete="off"
                                                            data-error={errors['excluded_medication'] ? "true" : "false"}
                                                        />
                                                        {touched['excluded_medication'] && errors['excluded_medication'] && (
                                                            <ErrorMessage name="excluded_medication" component="div" className="text-danger" />
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">

                                               

                                              
                                                <div className="col-xl-12 mb-4">
                                                    <label htmlFor="donor_restriction" className="form-label">Donor Restrictions </label>
                                                    <Field
                                                        type="text"
                                                        placeholder="Type here"
                                                        name="donor_restriction"
                                                        className="form-control" autoComplete="off"
                                                        data-error={errors['donor_restriction'] ? "true" : "false"}
                                                    />
                                                    {touched['donor_restriction'] && errors['donor_restriction'] && (
                                                        <ErrorMessage name="donor_restriction" component="div" className="text-danger" />
                                                    )}
                                                </div>

                                            </div>

                                            {/* <div className="row">
                                                <div className="col-xl-6 mb-2">
                                                    <div className="row">
                                                        <div className="col-xl-6 mb-2">
                                                            <label htmlFor="age_from" className="form-label">Age Range From</label>
                                                            <Field
                                                                type="number"
                                                                min="1"
                                                                placeholder="Type here"
                                                                name="age_from"
                                                                className="form-control"
                                                                onKeyDown={handleDecimalNumber}
                                                                autoComplete="off"
                                                                data-error={errors['age_from'] ? "true" : "false"}
                                                            />
                                                            {touched['age_from'] && errors['age_from'] && (
                                                                <ErrorMessage name="age_from" component="div" className="text-danger" />
                                                            )}
                                                        </div>
                                                        <div className="col-xl-6 mb-2">
                                                            <label htmlFor="age_to" className="form-label">To</label>
                                                            <Field
                                                                type="number"
                                                                 min="1"
                                                                placeholder="Type here"
                                                                name="age_to"
                                                                className="form-control"
                                                                onKeyDown={handleDecimalNumber}
                                                                autoComplete="off"
                                                                data-error={errors['age_to'] ? "true" : "false"}
                                                            />
                                                            {touched['age_to'] && errors['age_to'] && (
                                                                <ErrorMessage name="age_to" component="div" className="text-danger" />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}

                                        </div>

                                    </div>

                                    <div ref={sampleRef} id="sampleRequest" className="el-bg-table el-super-admin el-sr mb-4 mt-4 p-4 pb-1">
                                        <div className="el-bg-content-inner el-bg-content-inner-sr">
                                            <h3 className="el-title mt-1 mb-2">
                                                Sample Request
                                                {values.matched_sample == 'Yes' && (
                                                    <span className="ms-4 bg-danger text-white p-1 px-sm-3 rounded-3"><i className="el-icon-match"></i> Job contains matched samples</span>
                                                )}
                                            </h3>
                                            <button onClick={(e) => toggleCollapseBox(300, e)} className="el-bg-collapsable" type="button"><i className="el-icon-up"></i></button>
                                        </div>

                                        <div
                                            ref={(el) => (boxRefs.current[300] = el)}
                                            className="el-bg-collapsible-content el-bg-collapsible-content-sr open"
                                        >
                                            <div className="  row">
                                                <div className="col-xl-12 mb-2">

                                                    <button
                                                        type="button"
                                                        className="el-main-button me-0 p-2 px-4"
                                                        onClick={(e) => toggleSampleDropdown(e, isOpen)}
                                                        aria-haspopup="true"
                                                        aria-expanded={isOpen}
                                                        ref={selectSampleRequestRef}
                                                    ><span>Add/Remove Sample Type(s)</span></button>

                                                    {isOpen && (
                                                        <div className="dropdown-menu sample-type-dropdown-menu show" style={{ position: 'absolute' }}>
                                                            <h3 className="mb-3">Select Sample Type(s)</h3>
                                                            <div className="mb-3">
                                                                {samples && samples.length > 0 && (
                                                                    <>
                                                                        {samples.map((option) => (
                                                                            <div key={option.identifier} className="form-check">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    id={`checkbox-${option.id}`}
                                                                                    checked={!!selectedSampleIds[option.id]}
                                                                                    onChange={() => handleSampleChange(setFieldValue, option.id, !!selectedSampleIds[option.id])}
                                                                                    name="sample_types"
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`checkbox-${option.id}`}>
                                                                                    {option.name}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                )}
                                                            </div>
                                                            {sampleTypeError && <div className="text-danger pb-2">{sampleTypeError}</div>}
                                                            <div className="d-flex justify-content-start ">
                                                                <button type="button" className="el-main-button me-0" onClick={() => handleSampleApply()}><span>Add</span></button>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <button type="button" className="el-main-button me-0" onClick={() => handleSampleClose()}><span>Close</span></button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    
                                                    {touched['sample_types'] && errors['sample_types'] && (
                                                        <ErrorMessage name="sample_types" component="div" className="text-danger" />
                                                    )}
                                                </div>
                                            </div>

                                            {selectedSamples.length > 1 && (
                                                <div className="row">
                                                    <div className="col-xl-8 mb-3 radio-wrapper">
                                                        <label htmlFor="matched_sample" className="form-label-check">Are these matched samples?<span className="text-red">*</span></label>

                                                        <div className="d-flex mt-1">
                                                            {['Yes', 'No'].map((option) => (
                                                                <div className="form-check" key={option}>
                                                                    <Field type="radio"  id={`matched_sample_${option}`}  name="matched_sample" value={option} className="form-check-input" onChange={(e) => { handleSampleFieldChange(setFieldValue, 'matched_sample', e.target.value) }} autoComplete="off" data-error={errors['matched_sample'] ? "true" : "false"} />
                                                                    <label htmlFor={`matched_sample_${option}`}  className="form-check-label">&nbsp; {option}</label>
                                                                </div>
                                                            ))}
                                                            
                                                        </div>
                                                        <div className="el-display-block mt-1">
                                                            {touched['matched_sample'] && errors['matched_sample'] && (
                                                                <ErrorMessage name="matched_sample" component="div" className="text-danger" />
                                                            )}
                                                        </div>

                                                    </div>
                                                    {values.matched_sample == 'Yes' && (
                                                        <div className="mb-4">Matched samples are different sample types (e.g. blood AND urine) from the same donor.</div>
                                                    )}
                                                </div>
                                            )}

                                            {selectedSamples.length > 1 && values.matched_sample == 'Yes' && (
                                                <div className="el-bg-table el-bg-inner-table el-super-admin mb-4 mt-2 p-4 pb-1">
                                                    <div className="el-bg-content-inner">
                                                        <h3 className="el-title mt-1 mb-2">
                                                            {/* Special Donor Requests */}
                                                            Would you like to specify individual donors or donor demographics?
                                                        </h3>
                                                        <button onClick={(e) => toggleCollapseBox(400, e, 'sample')} className="el-bg-collapsable" type="button"><i className="el-icon-up"></i></button>
                                                    </div>
                                                    <div
                                                        ref={(el) => (boxRefs.current[400] = el)}
                                                        className="el-bg-collapsible-content open"
                                                    >
                                                        <div className="mt-4 row">
                                                            <div className="col-xl-12 mb-0 radio-wrapper">
                                                                <label htmlFor="is_special_donor" className="form-label-check">
                                                                    {/* Special Donor Requests? */}
                                                                    Want to invite donors by Donor ID or demographics?
                                                                     <span className="text-red">*</span></label>

                                                                <div className="d-flex ">
                                                                    {['Yes', 'No'].map((option) => (
                                                                        <div className="form-check" key={option}>
                                                                            <Field type="radio" id={`is_special_donor_${option}`}  name="is_special_donor" value={option} className="form-check-input" onChange={(e) => { handleSampleFieldChange(setFieldValue, 'is_special_donor', e.target.value) }} autoComplete="off" data-error={errors['is_special_donor'] ? "true" : "false"} />
                                                                            <label  htmlFor={`is_special_donor_${option}`}  className="form-check-label">&nbsp; {option}</label>
                                                                        </div>
                                                                    ))}
                                                                    
                                                                </div>
                                                                <div className="el-display-block mt-1">
                                                                    {touched['is_special_donor'] && errors['is_special_donor'] && (
                                                                        <ErrorMessage name="is_special_donor" component="div" className="text-danger" />
                                                                    )}
                                                                </div>

                                                            </div>
                                                        </div>
                                                        {values.is_special_donor === 'Yes' && (
                                                            <>
                                                                {renderSpecialDonor(setFieldValue, setSpecialDonor, specialDonor, selectedDonorIds, setSelectedDonorIds)}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="el-bg-table el-bg-inner-table el-super-admin mb-4 mt-2 p-4 pb-1">
                                                <div className="el-bg-content-inner">
                                                    <h3 className="el-title mt-1 mb-2">
                                                        Exclude Donors
                                                    </h3>
                                                    <button onClick={(e) => toggleCollapseBox(500, e, 'sample')} className="el-bg-collapsable" type="button"><i className="el-icon-up"></i></button>
                                                </div>
                                                <div
                                                    ref={(el) => (boxRefs.current[500] = el)}
                                                    className="el-bg-collapsible-content open"
                                                >
                                                    <div className="mt-4 row">
                                                        <div className="col-xl-12 mb-2 radio-wrapper">
                                                            <label htmlFor="is_exclude_donor" className="form-label-check">Would you like to exclude a specific donor?<span className="text-red">*</span></label>

                                                            <div className="d-flex mt-1">
                                                                {['Yes', 'No'].map((option) => (
                                                                    <div className="form-check" key={option}>
                                                                        <Field id={`is_exclude_donor_${option}`}  type="radio" name="is_exclude_donor" value={option} className="form-check-input" autoComplete="off"
                                                                            onChange={(e) => { handleSampleFieldChange(setFieldValue, 'is_exclude_donor', e.target.value); }} data-error={errors['is_exclude_donor'] ? "true" : "false"} />
                                                                        <label htmlFor={`is_exclude_donor_${option}`}  className="form-check-label">&nbsp; {option}</label>
                                                                    </div>
                                                                ))}                                                                
                                                            </div>
                                                            <div className="el-display-block mt-1">
                                                                {touched['is_exclude_donor'] && errors['is_exclude_donor'] && (
                                                                    <ErrorMessage name="is_exclude_donor" component="div" className="text-danger" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {values.is_exclude_donor === 'Yes' && (
                                                        <ExcludedDonor
                                                            setFieldValue={setFieldValue}
                                                            selectedDonorIds={selectedDonorIds}
                                                            excludedDonorIds={excludedDonorIds}
                                                            setExcludedDonorIds={setExcludedDonorIds}
                                                            activeField={activeField}
                                                            setActiveField={setActiveField}
                                                        />
                                                    )}
                                                </div>
                                            </div>

                                            {selectedSamples.length > 0 && (
                                                <>
                                                    {selectedSamples.map((detail, index) => {

                                                        const sampleId = detail.id;
                                                        const expirationDate = sampleRequest[sampleId]?.expiration_date || "";
                                                        const unprocessNumber = sampleRequest[sampleId]?.unprocess_number || "";
                                                        const unprocessUnit = sampleRequest[sampleId]?.unprocess_unit || "";
                                                        const fastingDurationUnit = sampleRequest[sampleId]?.fasting_duration_unit || "";
                                                        const isFasting = sampleRequest[sampleId]?.is_fasting || "";
                                                        const fastingDuration = sampleRequest[sampleId]?.fasting_duration || "";
                                                        const instruction = sampleRequest[sampleId]?.instruction || "";
                                                        const years = parseInt(detail.expiration_duration, 10);
                                                        const endDate = new Date();
                                                        endDate.setFullYear(endDate.getFullYear() + years);

                                                        const isOpen = index === 0 ? "open" : "";
                                                        const iconClass = index === 0 ? "el-icon-up" : "el-icon-down";
                                                        // setDonorDemographicsDataFromDetails(sampleRequestDetails.request.rq_samples[sampleId-1].sample_request_demographics);
                                                        // console.log(sampleRequestDetails.request.rq_samples[sampleId-1].sample_request_demographics)
                                                        const donorDemographicsDataFromDetailsUnmatched = sampleRequestDetails?.request?.rq_samples?.find(s => s.sample_id === sampleId)?.sample_request_demographics || [];
                                                        return (
                                                            <div className="el-bg-table el-bg-inner-table el-super-admin mb-4 mt-2 p-4 pb-1" key={index}>
                                                                <div className="el-bg-content-inner">
                                                                    <h3 className="el-title mt-1 mb-2 sample-heading">
                                                                        <span className={`sample-type ${detail.button_class}`}><i className={detail.class_name}></i>{detail.name}</span>
                                                                    </h3>
                                                                    {/*  handleSampleRemovalAction(sampleId) */}
                                                                    <button onClick={() => handleShowDeleteModal(sampleId)} className={`el-bg-collapsable el-bg-collapsable-delete el-bg-sample-collapsable-${4 + sampleId}`} type="button"><i className="el-icon-trash"></i></button>
                                                                    <button onClick={(e) => toggleCollapseBox(600 + sampleId, e, sampleId)} className={`el-bg-collapsable el-bg-sample-collapsable-${4 + sampleId}`} type="button"><i className={iconClass}></i></button>
                                                                </div>

                                                                <div
                                                                    ref={(el) => (boxRefs.current[600 + sampleId] = el)}
                                                                     className={`el-bg-collapsible-content ${isOpen}`}
                                                                >
                                                                    <div className="mt-4 row">
                                                                        {/* added wrapper div for data-error for auto scroll-up on submit error */}
                                                                        <div 
                                                                            className={`form-group ${errors[`expiration_date_${sampleId}`] ? "has-error" : ""}`} 
                                                                            data-error={errors[`expiration_date_${sampleId}`] ? "true" : "false"}
                                                                        > 
                                                                        <div className="col-xl-5 mb-0">
                                                                            <label htmlFor={`expiration_date_${sampleId}`} className="form-label">Sample’s Expiration Date <span className="text-red">*</span></label>
                                                                            <DatePicker
                                                                                selected={expirationDate}
                                                                                onChange={(date) => handleSampleFieldChange(setFieldValue, 'expiration_date', date, sampleId)}
                                                                                minDate={minStartDate}
                                                                                maxDate={endDate}
                                                                                dateFormat={dateFormat}
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                placeholderText="Select Expiration Date"
                                                                                name={`expiration_date_${sampleId}`}
                                                                                id={`expiration_date_${sampleId}`}
                                                                                className="form-control"
                                                                                data-error={errors[`expiration_date_${sampleId}`] ? "true" : "false"}
                                                                                autoComplete="off"
                                                                            />
                                                                            {/* &&  touched[`expiration_date_${sampleId}`]  */}
                                                                            {errors[`expiration_date_${sampleId}`] &&  touched[`expiration_date_${sampleId}`] && (
                                                                                <div className="text-danger">{errors[`expiration_date_${sampleId}`]}</div>
                                                                            )}
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-xl-12 mb-4">

                                                                            <div className="row">
                                                                                <div className="col-xl-7">
                                                                                    <label htmlFor={`unprocess_number_${sampleId}`} className="form-label">How long can the sample remain unprocessed? <span className="text-red">*</span></label>
                                                                                    <Field
                                                                                        type="number"
                                                                                        min="0"
                                                                                        onKeyDown={handleDecimalNumber}
                                                                                        placeholder="Type here"
                                                                                        name={`unprocess_number_${sampleId}`}
                                                                                        className="form-control"
                                                                                        onChange={(e) => { handleSampleFieldChange(setFieldValue, 'unprocess_number', e.target.value, sampleId) }}
                                                                                        value={unprocessNumber} autoComplete="off"
                                                                                        data-error={errors[`unprocess_number_${sampleId}`] ? "true" : "false"}
                                                                                    />
                                                                                    {errors[`unprocess_number_${sampleId}`] && touched[`unprocess_number_${sampleId}`] && (
                                                                                        <div className="text-danger">{errors[`unprocess_number_${sampleId}`]}</div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-xl-5">
                                                                                    <label htmlFor={`unprocess_number_${sampleId}`} className="form-label"> Unprocessed unit<span className="text-red">*</span></label>
                                                                                    <Field
                                                                                        as="select"
                                                                                        name={`unprocess_unit_${sampleId}`}
                                                                                        className="form-control"
                                                                                        onChange={(e) => handleSampleFieldChange(setFieldValue, 'unprocess_unit', e.target.value, sampleId)}
                                                                                        value={unprocessUnit} autoComplete="off"
                                                                                        data-error={errors[`unprocess_unit_${sampleId}`] ? "true" : "false"}
                                                                                    >
                                                                                        {Object.entries(duration).map(([key, value]) => (
                                                                                            <option key={key} value={key}>{value}</option>
                                                                                        ))}
                                                                                    </Field>
                                                                                    {errors[`unprocess_unit_${sampleId}`] && touched[`unprocess_unit_${sampleId}`] && (
                                                                                        <div className="text-danger">{errors[`unprocess_unit_${sampleId}`]}</div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-xl-6 mb-4 radio-wrapper">
                                                                            <label htmlFor={`is_fasting_${sampleId}`} className="form-label-check">Is Fasting Required? <span className="text-red">*</span></label>
                                                                            <div className="d-flex mt-1">
                                                                                {['Yes', 'No'].map((option) => (
                                                                                    <div className="form-check" key={option}>
                                                                                        <Field type="radio" id={`is_fasting_${sampleId}_${option}`} name={`is_fasting_${sampleId}`} value={option} className="form-check-input" onChange={(e) => { handleSampleFieldChange(setFieldValue, 'is_fasting', e.target.value, sampleId) }} autoComplete="off" data-error={errors[`is_fasting_${sampleId}`] ? "true" : "false"} />
                                                                                        <label htmlFor={`is_fasting_${sampleId}_${option}`} className="form-check-label">&nbsp; {option}</label>
                                                                                    </div>
                                                                                ))}
                                                                                {errors[`is_fasting_${sampleId}`] && touched[`is_fasting_${sampleId}`] && (
                                                                                    <div className="text-danger">{errors[`is_fasting_${sampleId}`]}</div>
                                                                                )}
                                                                            </div>

                                                                        </div>

                                                                        {isFasting === 'Yes' && (                                                                            
                                                                            <div className="col-xl-6 mb-4 radio-wrapper d-flex justify-content-start align-items-center">
                                                                                <div>

                                                                                <label htmlFor={`fasting_duration_${sampleId}`} className="form-label">If Yes, please enter the duration <span className="text-red">*</span></label>
                                                                                <Field
                                                                                    type="number"
                                                                                    min="1"
                                                                                    name={`fasting_duration_${sampleId}`}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key ==="-"  || e.key ==="+" ) {
                                                                                            e.preventDefault();
                                                                                        } 
                                                                                    }}
                                                                                    placeholder="Type here"
                                                                                    className="form-control"
                                                                                    onChange={(e) => { handleSampleFieldChange(setFieldValue, 'fasting_duration', e.target.value, sampleId) }}
                                                                                    value={fastingDuration} 
                                                                                    autoComplete="off"
                                                                                    data-error={errors[`fasting_duration_${sampleId}`] ? "true" : "false"}
                                                                                />
                                                                                </div>

                                                                                <div className="ms-4">
                                                                                    <label htmlFor={`fasting_duration_unit_${sampleId}`} className="form-label"> Duration <span className="text-red">*</span></label>
                                                                                    <Field
                                                                                        as="select"
                                                                                        name={`fasting_duration_unit_${sampleId}`}
                                                                                        className="form-control"
                                                                                        onChange={(e) => handleSampleFieldChange(setFieldValue, 'fasting_duration_unit', e.target.value, sampleId)}
                                                                                        value={fastingDurationUnit} autoComplete="off"
                                                                                        data-error={errors[`fasting_duration_unit_${sampleId}`] ? "true" : "false"}
                                                                                    >
                                                                                        {Object.entries(duration).map(([key, value]) => (
                                                                                            <option key={key} value={key}>{value}</option>
                                                                                        ))}
                                                                                    </Field>
                                                                                    {errors[`fasting_duration_unit_${sampleId}`] && touched[`fasting_duration_unit_${sampleId}`] && (
                                                                                        <div className="text-danger">{errors[`fasting_duration_unit_${sampleId}`]}</div>
                                                                                    )}                                                                                
                                                                                </div>
                                                                                {errors[`fasting_duration_${sampleId}`] && touched[`fasting_duration_${sampleId}`] && (
                                                                                    <div className="text-danger">{errors[`fasting_duration_${sampleId}`]}</div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    
                                                                    <CustomFields
                                                                        fields={getFieldsBySampleId(sampleId)}
                                                                        sampleId={sampleId}
                                                                        setFieldValue={setFieldValue}
                                                                        error={customFieldError}
                                                                        setError={setCustomFieldError}
                                                                        sampleRequest={setSampleRequest}
                                                                        sampleRequestData = {sampleRequest}
                                                                        setBloodVolume={setBloodVolume}
                                                                        sampleFieldRef={sampleFieldRef}
                                                                        groupTotal={groupTotal}
                                                                        setGroupTotal={setGroupTotal} 
                                                                    />

                                                                <div className="row">
                                                                    <div className="col-xl-12 mb-4 radio-wrapper">
                                                                            <label htmlFor={`instruction_${sampleId}`} className="form-label">Special Instructions</label>
                                                                            <Field
                                                                                type="text"
                                                                                name={`instruction_${sampleId}`}
                                                                                className="form-control"
                                                                                onChange={(e) => { handleSampleFieldChange(setFieldValue, 'instruction', e.target.value, sampleId) }}
                                                                                value={instruction} autoComplete="off"
                                                                                placeholder="Type here"
                                                                                data-error={errors[`instruction_${sampleId}`] ? "true" : "false"}
                                                                            />
                                                                            {errors[`instruction_${sampleId}`] && touched[`instruction_${sampleId}`] && (
                                                                                <div className="text-danger">{errors[`instruction_${sampleId}`]}</div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {(values.matched_sample == 'No' || values.matched_sample == '') && (
                                                                        <div className="el-bg-table el-bg-inner-table el-super-admin mb-4 mt-2 p-4 pb-1">
                                                                            <div className="el-bg-content-inner">
                                                                                <h3 className="el-title mt-1 mb-2">
                                                                                    Special Donor Requests
                                                                                </h3>
                                                                                <button onClick={(e) => toggleCollapseBox( sampleId + 2 + selectedSamples.length + 600, e, 'sample')} className="el-bg-collapsable" type="button"><i className="el-icon-up"></i></button>
                                                                            </div>
                                                                            <div
                                                                                ref={(el) => (boxRefs.current[sampleId+ 2 +  selectedSamples.length + 600 ] = el)}
                                                                                className="el-bg-collapsible-content open"
                                                                            >
                                                                                <div className="mt-4 row">
                                                                                    <div className="col-xl-6 mb-2 radio-wrapper">
                                                                                        <label htmlFor={`is_special_donor_${sampleId}`} className="form-label-check">Special Donor Requests? <span className="text-red">*</span></label>

                                                                                        <div className="d-flex mt-1">
                                                                                            {['Yes', 'No'].map((option) => (
                                                                                                <div className="form-check" key={option}>
                                                                                                    <Field type="radio" id={`is_special_donor_${sampleId}_${option}`}  name={`is_special_donor_${sampleId}`} value={option} className="form-check-input" onChange={(e) => { handleSampleFieldChange(setFieldValue, 'is_special_donor', e.target.value, sampleId) }} autoComplete="off" data-error={errors[`is_special_donor_${sampleId}`] ? "true" : "false"} />
                                                                                                    <label htmlFor={`is_special_donor_${sampleId}_${option}`} className="form-check-label">&nbsp; {option}</label>
                                                                                                </div>
                                                                                            ))}
                                                                                            
                                                                                        </div>
                                                                                        <div className="el-display-block mt-1">
                                                                                            {errors[`is_special_donor_${sampleId}`] && touched[`is_special_donor_${sampleId}`] && (
                                                                                                <div className="text-danger">{errors[`is_special_donor_${sampleId}`]}</div>
                                                                                            )}
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                                {values[`is_special_donor_${sampleId}`] === 'Yes' && (
                                                                                    <>
                                                                                        {renderSpecialDonor(setFieldValue, setSampleRequest, sampleRequest[sampleId], sampleRequest[sampleId].selected_donor_ids, setSampleRequest, sampleId, donorDemographicsDataFromDetailsUnmatched)}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </div>

                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            )}


                                        </div>

                                    </div>

                                    <div className="el-bg-table el-super-admin el-sr mb-4 mt-4 p-4 pb-1">
                                        <div className="el-bg-content-inner el-bg-content-inner-sr">
                                            <h3 className="el-title mt-1 mb-2">Schedule Sample Collection</h3>
                                            <button
                                                onClick={(e) => toggleCollapseBox(selectedSamples.length > 0 ? selectedSamples.length + 700 : 700, e)}
                                                className="el-bg-collapsable"
                                                type="button"
                                            >
                                                <i className="el-icon-up"></i>
                                            </button>
                                        </div>

                                        <div

                                            ref={(el) => (boxRefs.current[selectedSamples.length > 0 ? selectedSamples.length + 700 : 700] = el)}
                                            className="el-bg-collapsible-content el-bg-collapsible-content-sr open"
                                        // style={{ overflow: 'hidden', transition: 'height 0.3s ease', height: 'auto' }}
                                        >

                                            <p className="mt-4">Your request requires a {totalDuration} min appointment block.</p>
                                            <Row className="my-2">
                                                <Col md={12}>
                                                    <p>
                                                        Do you require your samples at a specific time of the day?{' '}
                                                        <span className="text-danger">*</span>
                                                    </p>
                                                </Col>
                                                <Col md={8} className="d-flex justify-content-start">
                                                    <Col className="my-3">

                                                        <div className="d-flex justify-content-start" data-error={errors['scheduled_pickup'] ? "true" : "false"} >
                                                            <button className="el-main-button me-0 p-2 px-4" onClick={(e) => handleSchedulePickupClick(e, "no-preferable")} >
                                                                {/* <i className="el-icon-add-person"></i> */}
                                                                <span> No (preferable), Schedule Now</span>
                                                            </button>&nbsp;&nbsp;&nbsp;&nbsp;
                                                            <button className="el-main-button me-0 p-2 px-4 " onClick={(e) => handleSchedulePickupClick(e, "preferable")}  >
                                                                {/* <i className="el-icon-add-person"></i> */}
                                                                <span> Yes, Schedule Now</span>
                                                            </button>
                                                        </div>

                                                        <div className="mt-1">
                                                            {values.scheduled_pickup && (<p>Your scheduled pickup date:  {new Date(values.scheduled_pickup.scheduledDate).toLocaleDateString("en-US", {
                                                                weekday: "long", // Add the day name
                                                                year: "numeric",
                                                                month: "long",
                                                                day: "numeric",
                                                            })} | {(() => {
                                                                const [hour, minute] = values.scheduled_pickup.selectedTime.split(':').map(Number);
                                                                const ampm = hour >= 12 ? 'PM' : 'AM';
                                                                const formattedHour = hour % 12 || 12; // Convert 0 hour to 12 for 12-hour format
                                                                return `${formattedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
                                                            })()}</p>)}
                                                        </div>
                                                        {/* <Field
                                                            type="datetime-local"
                                                            className="form-control"
                                                            placeholder="Type here"
                                                            name="scheduled_pickup"
                                                            value={new Date().toISOString().slice(0, 16)}
                                                        /> */}

                                                        {errors['scheduled_pickup'] && (
                                                            (<div className="text-danger mt-3">{errors[`scheduled_pickup`]}</div>)

                                                        )}
                                                    </Col>
                                                </Col>
                                            </Row>
                                            <p>Samples available on or after:</p>
                                            <div className="my-2">
                                                <div>
                                                    {pickupDaysAvailableWRTSampleCount.length > 0 ? (
                                                        <ul>
                                                            {pickupDaysAvailableWRTSampleCount.map((pickupDay) => (
                                                                <li key={pickupDay.id}>
                                                                    {pickupDay.max_sample
                                                                        ? `${pickupDay.min_sample} to ${pickupDay.max_sample} samples | ${pickupDay.day} Business days`
                                                                        : `${pickupDay.min_sample}+ samples | ${pickupDay.day} Business days`}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>Loading data...</p>
                                                    )}
                                                </div>
                                                {/* <p> 
                                                    1 to 5 samples | 3 Business days <br />
                                                    6 to 9 samples | 6 Business days <br />
                                                    10+ samples | 11 Business days
                                                </p> */}
                                            </div>
                                            <p>
                                                * If you're able to select the first available appointment on a specific day, that will help
                                                us maximize the number of collections we can do in a single day.
                                            </p>

                                        </div>
                                    </div>

                                    <div className="el-bg-table el-super-admin el-sr mb-4 mt-4 p-4 pb-1">
                                        <div className="el-bg-content-inner el-bg-content-inner-sr">
                                            <h3 className="el-title mt-1 mb-2">Acknowledgement</h3>
                                            <button
                                                onClick={(e) => toggleCollapseBox(selectedSamples.length > 0 ? selectedSamples.length + 800 : 800, e)}
                                                className="el-bg-collapsable"
                                                type="button"
                                            >
                                                <i className="el-icon-up"></i>
                                            </button>
                                        </div>
                                        <div
                                            ref={(el) => (boxRefs.current[selectedSamples.length > 0 ? selectedSamples.length + 800 : 800] = el)}
                                            className="el-bg-collapsible-content el-bg-collapsible-content-sr open"
                                        // style={{ overflow: 'hidden', transition: 'height 0.3s ease', height: 'auto' }}
                                        >
                                            <Row className="mt-4 my-4">
                                                <p className="text-danger">Researcher should be prepared to transport sample using labeled, covered secondary containment</p>
                                                <p> <i>*I verify that I have read and understood both the Clinical Protocol NOCOMPOUNDNAP1001- Amendment 10 “Generation of reagents from human-derived biological samples for the development and control of laboratory assays and procedures” and the latest version of TV-SOP-11772 “Request and Use of Bodily Fluids and Tissue Samples From Employee Volunteer Donors”.</i></p>
                                                <p> <i>*I acknowledge that the sample(s) I am receiving have not been tested for infectious diseases.</i> </p>

                                                <div className="el-form-group my-2 col-md-4 col-6">
                                                    <label className="form-label">Initial</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Type here"
                                                        name="initial"  // Name should match the field in initialValues
                                                        autoComplete="off"
                                                        data-error={errors[`initial`] ? "true" : "false"}
                                                    />
                                                    <ErrorMessage name="initial" component="div" className="text-danger" />
                                                </div>

                                            </Row>
                                        </div>
                                    </div>

                                    <div className=" d-flex align-items-center">
                                        <button type="submit"
                                            onClick={async (e) => {
                                                // e.preventDefault(); // Prevent default behavior  i.e page reload
                                                const validationErrors = await validateForm();  // checking here -> if no error then only do submit form with isDraft bool
                                                
                                                if (Object.keys(validationErrors).length === 0) {
                                                    // handleSubmit(values, false); 
                                                    handleShowSubmitModal(values, false);
                                                }
                                                else {
                                                    handleScrollUpOnSubmit(validationErrors);
                                                }
                                            }}
                                            className="el-main-button"><span>Submit</span></button>
                                                <button
                                                    type="button"
                                                    onClick={async (e) => {
                                                        const validationErrors = await validateForm();

                                                        // Filter errors for project_name and lab_id
                                                        const draftErrors = Object.keys(validationErrors).filter(
                                                            (key) => key === 'project_name' || key === 'lab_id'
                                                        );

                                                        // Check if there are no errors in project_name and lab_id
                                                        if (draftErrors.length === 0) {
                                                            handleSubmit(values, true); // Call handleSubmit when there are no errors
                                                        } else {
                                                            handleScrollUpOnDraftSubmit(validationErrors); // Scroll to the errors
                                                        }
                                                    }}
                                                    className="el-main-button"
                                                >
                                                    <span>Save Draft</span>
                                                </button>

                                        <Link className="back-link" to={`${previousUrl}`}><span>Close</span></Link>
                                    </div></div>
                                    
                                    <SchedulePickupSampleRequestModal
                                        show={showTrainingModal}
                                        onConfirm={confirmPickupModal}
                                        handleClose={handleCloseTrainingModal}
                                        type={scheduleType}
                                        duration={totalDuration}
                                        sample_count={selectedSamples.length * voluenteers}
                                        lab_id={values.lab_id}
                                    />

                                    
                                     {/* <div>
                                        <h3>Values</h3>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(values, null, 2)}
                                        </pre>
                                        <h3>Errors</h3>
                                        <p>Total Errors: {Object.keys(errors).length}</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(errors, null, 2)}
                                        </pre>                                        
                                        <h3>Touched</h3>
                                        <p>Total Touched Fields: {Object.keys(touched).length}</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(touched, null, 2)}
                                        </pre>

                                        <p>Total Volumes: {Object.keys(groupTotal).length}</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(groupTotal, null, 2)}
                                        </pre>

                                        <p>Total Error: {Object.keys(customFieldError).length}</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(customFieldError, null, 2)}
                                        </pre>

                                        <p>bloodVolume Volumes</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(bloodVolume, null, 2)}
                                        </pre>
                                        
                                    </div>   */}

                                    {/* <div>
                                            <h3>Values</h3>
                                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                {JSON.stringify(values, null, 2)}
                                            </pre>
                                            <h3>Errors</h3>
                                            <p>Total Errors: {Object.keys(errors).length}</p>
                                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                {JSON.stringify(errors, null, 2)}
                                            </pre>                                        
                                            <h3>Touched</h3>
                                            <p>Total Touched Fields: {Object.keys(touched).length}</p>
                                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                {JSON.stringify(touched, null, 2)}
                                            </pre>

                                            <h3>selectedSamples</h3>
                                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                {JSON.stringify(selectedSamples, null, 2)}
                                            </pre>
                                            
                                    </div>  */}

                                </Form></>
                            );
                        }}
                    </Formik>
                    <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />

                    {/* Delete Confirmation Modal */}
                    <ConfirmationModal
                        show={showDeleteModal}
                        onHide={handleCloseDeleteModal}
                        onConfirm={confirmDeleteUser}
                        title="Confirm remove"
                        body="Are you sure you want to remove this Sample Type?"
                        type='remove-st'
                    />

                    <ConfirmationModal
                            show={showProfileSettingsModal}
                            onHide={handleCloseProfileSettingsModal}
                            onConfirm={confirmProfileSettings}
                        
                            body="This sample request can not be saved until you add a Project Name and Lab. Are you sure you want to leave this page without saving?"
                            type="donor-no-show"
                        />
                    {/* Submit Confirmation Modal */}
                    <ConfirmationModal
                        show={showSubmitModal}
                        onHide={handleCloseSubmitModal}
                        onConfirm={confirmSubmit}
                        title="Confirm save"
                        body="Are you sure you are ready to submit?"
                        type='save-sr'
                    />
                </div>
            </div>

        </>
    );
}

export default NewRequest;